// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.development {
  background: url("https://s3-ap-southeast-1.amazonaws.com/meesho-static/web/dev.png") repeat;
}

.order-booked .btn.btn-info {
  width: 100px;
}

.min_num_delays {
  width: 70px;
  height: 34px;
  padding: 0 5px;
}

input.break {
  word-wrap: break-word;
  word-break: break-all;
  height: 80px;
}

.padding-bottom-5 {
  padding-bottom: 5px;
}

.padding-bottom-zero {
  padding-bottom: 0;
}

.padding-left-20 {
  padding-left: 20px;
}

.min-width-70 {
  min-width: 70px;
}

.catalog-send-notification {
  margin: 0 -1px;
}

.width-min-100 {
  min-width: 100px;
}

.form-control.width-min-100 {
  padding: 5px;
}

body,
html {
  margin: 0;
}

.border-radius-none {
  border-radius: 0 !important;
}

.product-image {
  width: 100px;
  height: 50px;
  object-fit: cover;
  margin: 0 5px;
}

.product-image-1 {
  width: 100%;
  max-height: 150px;
  max-width: 150px !important;
  object-fit: cover;
  border: none !important;
}

.product-image-2 {
  width: 100%;
  max-height: 100px;
  max-width: 100px !important;
  object-fit: cover;
  border: none !important;
}

.product-row-content .product-image-2 {
  max-height: 120px;
  height: 120px;
  max-width: 120px !important;
}

.margin-zero {
  margin: 0 !important;
}

.margin-top-1em {
  margin-top: 1em;
}

.margin-top-2em {
  margin-top: 2em;
}

.margin-top-0 {
  margin-top: 0px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-top-12 {
  margin-top: 12px;
}

.margin-top-15 {
  margin-top: 15px;
}

.margin-top-20 {
  margin-top: 20px !important;
}

.padding-top-10 {
  padding-top: 10px;
}

.margin-bottom-zero {
  margin-bottom: 0;
}

.margin-tb-10 {
  margin-bottom: 10px;
  margin-top: 10px;
}

.margin-tb-0 {
  margin-bottom: 0;
  margin-top: 0;
}

.margin-lr-10 {
  margin-left: 10px;
  margin-right: 10px;
}

.clear {
  clear: both;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.inline-block {
  display: inline-block;
  vertical-align: middle;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ffffff;
}

.table-auto {
  border-collapse: collapse;
}

.table > tbody > tr > td {
  border-top: 1px solid #c9d6de;
}

.table th,
.table td {
  border: 1px solid #c9d6de;
  text-align: center;
  word-break: break-all;
  font-size: 14px;
  vertical-align: middle !important;
}

.thead-wrapper {
  border-top: 1px solid lightgrey;
}

.table.text-top th,
.table.text-top td {
  vertical-align: top !important;
}

.table-auto th,
.table-auto td {
  padding: 10px;
  border: 1px solid #c9d6de;
  text-align: center;
  word-break: break-all;
  font-size: 14px;
  vertical-align: middle !important;
}

#supplierlist table {
  border-collapse: collapse;
  width: 100%;
}

.supplier-table td,
#page-wrapper th {
  border: 1px solid #c9d6de;
  text-align: center;
  padding: 15px 5px;
  word-break: break-all;
  font-size: 12px;
}

.width-50 {
  width: 50px;
}

.width-50-imp {
  width: 50px !important;
}

.width-80 {
  width: 80px;
}

.width-100 {
  width: 100px;
}

.width-110 {
  width: 110px;
}

.width-120 {
  width: 120px;
}

.width-130 {
  width: 130px;
}

.width-150 {
  width: 150px;
}

.width-300 {
  width: 300px;
}

.width-200 {
  width: 200px;
}

.width-185 {
  width: 185px;
}

.width-250 {
  width: 250px;
}

.width-70 {
  width: 70px;
}

.font-weight-500 {
  font-weight: 500;
}

.variable-label {
  font-weight: normal;
  width: 55%;
}

.variable-label-input {
  display: flex;
  margin-bottom: 5px;
}

.action-cta {
  min-width: 90px;
  padding: 10px 10px;
  margin: 0 5px;
  border-radius: 4px;
}

.action-cta.not-allowed {
  cursor: not-allowed;
}

.action-cta-1 {
  padding: 10px 30px;
  border-radius: 4px;
}

.action-cta-2 {
  padding: 10px 0;
  border-radius: 4px;
}

.action-cta-3 {
  padding: 8px 10px;
  margin: 0 7px;
  border-radius: 0;
  min-width: 100px;
}

.margin-top-10 {
  margin-top: 10px;
}

.page-sub-header {
  font-size: 20px;
  font-weight: 700;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.supplier-page .page-sub-header {
  border-bottom: none;
}

.delete-block {
  border: 1px solid #c9d6de;
  padding: 30px 15px;
  border-radius: 4px;
}

.shadow {
  -webkit-box-shadow: 1px 2px 5px 6px #c9d6de;
  -moz-box-shadow: 1px 2px 5px 6px #c9d6de;
  box-shadow: 1px 2px 5px 6px #c9d6de;
}

.shadow-lite {
  -webkit-box-shadow: 1px 2px 3px 3px #a7a7a74b;
  -moz-box-shadow: 1px 2px 3px 3px #a7a7a74b;
  box-shadow: 1px 2px 3px 3px #a7a7a74b;
}

.fileInput {
  padding: 10px;
  margin: 15px 0;
  cursor: pointer;
  border: 1px solid #c9d6de;
  width: 300px;
}

.imgPreview {
  text-align: center;
  margin: 15px 0;
  width: 300px;
  max-height: 200px;
  border: 1px solid #c9d6de;
}

.imgPreview img {
  width: 100%;
}

.previewText {
  padding: 40px 15px;
  font-size: 16px;
  font-weight: 700;
  width: 300px;
}

.add-new-catalog .fileInput,
.add-new-catalog .previewText,
.add-new-catalog .imgPreview {
  width: 100%;
}

.add-new-catalog .imgPreview {
  width: 100%;
  max-height: 100%;
}

.catalog-view-info {
  padding: 5px 5px 0;
}

.catalog-view,
.collection-view {
  margin-bottom: 30px;
}

.catalog-container,
.collection-container {
  float: none;
  width: 25%;
  display: inline-block;
  vertical-align: top;
}

.collection-container.col-md-3 {
  padding: 0 5px;
}

.catalog-view-catalog-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.border {
  border: 1px solid #c9d6de;
}

.border-top {
  border-top: 1px solid #c9d6de;
}

.border-bottom {
  border-bottom: 1px solid #c9d6de;
}

.border-left {
  border-left: 1px solid #c9d6de;
}

.border-right {
  border-right: 1px solid #c9d6de;
}

.catalog-view-image img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.font-20 {
  font-size: 20px;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.font-15 {
  font-size: 15px;
}

.font-14 {
  font-size: 14px;
}

.font-12 {
  font-size: 12px;
}

.font-11 {
  font-size: 11px;
}

.font-10 {
  font-size: 10px;
}

.font-13 {
  font-size: 13px;
}

.padding-bottom-10 {
  padding-bottom: 10px;
}

.padding-bottom-20 {
  padding-bottom: 20px;
}

.bold {
  font-weight: 700;
}

.normal {
  font-weight: 400;
}

.catalog-view-action-cta .link-2 {
  width: 50%;
  border-radius: 0;
  padding: 10px 5px;
}

.catalog-view-action-cta .link-1 {
  width: 100%;
  border-radius: 0;
  padding: 10px 5px;
}

.radio-inline {
  margin-left: 20px;
}

.radio-inline-custom {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
  margin-top: 4px;
}

.radio-inline-custom .label {
  margin-right: 8px;
}

.radio-inline.m-0 {
  margin: 0;
}

label {
  font-size: 16px;
}

label.min-width-110 {
  min-width: 110px;
}

.form-control {
  border-radius: 0;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  border: 1px solid #c9d6de;
  box-shadow: none !important;
}

.form-control:focus {
  border-color: #0f213c;
}

.drop-images-zone {
  display: block;
  padding: 50px;
  cursor: pointer;
}

.drop-images-uploaded {
  max-width: 100px;
  max-height: 100px;
  margin: 0 10px;
}

.single-product-upload-row {
  width: 100%;
  border-bottom: 0 !important;
}

.product-row-heading .float-left {
  padding: 10px 5px;
  text-align: center;
  font-weight: 700;
  border-left: 1px solid #c9d6de;
  font-size: 12px;
}

.product-upload-cross {
  margin-top: 10px;
}

.product-row-content .float-left {
  padding: 5px;
}

.product-row-content .form-control {
  padding: 6px 5px;
}

.product-uploaded-image {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border: 1px solid #c9d6de;
}

.product-image-upload {
  width: 100px;
}

.product-autofill-checkbox {
  margin-left: 20px;
  margin-top: 0;
}

.product-upload-data td {
  vertical-align: top !important;
}

.image-full {
  width: 100%;
}

.panel {
  border-radius: 0;
}

.relative {
  position: relative;
}

.catalog-image-edit {
  width: 100%;
}

.product-uploaded-image-cross {
  position: absolute;
  right: 0;
  top: 0;
}

.product-upload-images .fileInput {
  max-width: 100%;
}

.display-flex {
  display: flex;
}

.catalog-edit-action a {
  min-width: 150px;
  padding: 10px 5px;
}

.catalog-edit-action button {
  min-width: 150px;
  padding: 10px 5px;
}

.catalog-edit-action .col-md-2 {
  width: 20%;
}

.padding-2em {
  padding: 2em 0;
}

.edit-catalog-product-add .product-name,
.edit-catalog-product-add .product-description {
  width: 18%;
}

.edit-catalog-product-add .product-upload-images {
  width: 10%;
}

.edit-catalog-product-add .product-full-catalog {
  width: 8%;
}

.product-row-heading,
.product-row-content {
  margin: 0;
}

.uploaded-image-done {
  position: relative;
  height: 120px;
  min-width: 100px !important;
}

.deleted-product,
.deleted-catalog,
.deleted-collection,
.deleted-widget-group {
  background-color: #cdcdcd;
}

.catalog-view-action-cta {
  margin: 0 -1px;
}

#supplierlist .table th,
#supplierlist .table th {
  font-size: 12px;
}

.uppercase {
  text-transform: uppercase;
}

.capitalize {
  text-transform: capitalize;
}

.padding-vertical-15 {
  padding: 0 15px;
}

.size-tag {
  position: relative;
  margin: 0 3px;
  color: #fff;
  background: #93a4af;
  font-weight: 700;
  display: inline-block;
  vertical-align: top;
  padding: 5px 30px 5px 15px;
  border-radius: 2px;
}

.size-remove {
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 4px;
  padding-left: 7px;
  padding-right: 7px;
  cursor: pointer;
  height: 100%;
  border-left: 1px solid #fff;
}

.text-center-important {
  text-align: center !important;
}

.added-sizes,
.add-size-button {
  display: inline-block;
  vertical-align: top;
}

.size-tag-margin {
  margin: 5px 2px;
}

.modal-outer {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1050;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: auto;
}

.overflow-unset {
  overflow: unset !important;
}

.modal-content {
  box-shadow: none;
  border: 1px solid #c9d6de;
  color: #52616a;
  padding: 20px;
  background-color: #ffffff;
}

.modal-inner {
  margin-top: 50px;
  max-width: 600px;
  z-index: 1060;
  background-color: #fff;
}

.modal-hidden {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.order-booked-popup .modal-inner,
.supplier-edit-popup .modal-inner {
  margin-top: 50px;
  max-width: 800px;
  width: 800px;
}

.supplier-edit-popup .modal-body {
  padding: 20px 20px;
}

.supplier-edit-popup .delete-confirm-button {
  margin-bottom: 10px;
}

.admin-delete-popup .modal-body {
  padding: 40px 20px;
}

.sub-order-reship-popup .modal-inner {
  margin-top: 50px;
  max-width: 85%;
  width: 85%;
}

.order-timeline-popup .modal-inner,
.payment-screen-shot .modal-inner {
  margin-top: 50px;
  max-width: 600px;
  width: 600px;
}

.order-exchange-popup .modal-inner {
  max-width: 880px;
  width: 880px;
  margin-top: 50px;
}

.order-return-popup .modal-inner {
  max-width: 580px;
  width: 580px;
  margin-top: 50px;
}

.add-size-body input {
  display: inline-block;
  vertical-align: top;
  margin: 3px 5px 10px 10px;
}

.modal-outer.opened {
  display: block;
}

.order-exchange-popup {
  overflow: hidden !important;
}

.col-md-20 {
  float: left;
  width: 20%;
  padding: 0 15px;
}

.catalog-view-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-wrapper {
  overflow-x: scroll;
  overflow-y: visible;
  width: 100%;
}

.inline-block-table {
  display: inline-block;
  border: 1px solid #c9d6de;
  vertical-align: middle;
  text-align: center;
  padding: 10px;
}

.scrollble-view {
  width: 100%;
  overflow: scroll;
  white-space: nowrap;
}

.display-flex {
  display: flex;
}

.scroll-table {
  width: 100%;
  overflow: auto;
  border-left: 1px solid #c9d6de;
  border-right: 1px solid #c9d6de;
}

.scroll-x {
  width: 100%;
  overflow-x: auto;
}

.scroll-table .table {
  margin-bottom: 0;
}

.scroll-table .table th:first-child,
.scroll-table .table td:first-child {
  border-left: 0 !important;
}

.scroll-table .table th:last-child,
.scroll-table .table td:last-child {
  border-right: 0 !important;
}

.scroll-table th,
.scroll-table td {
  min-width: 50px;
  min-height: 70px;
}

.scroll-table th.width-90,
.scroll-table td.width-90 {
  min-width: 90px;
}

.scroll-table th.width-70,
.scroll-table td.width-70 {
  min-width: 70px;
}

.scroll-table th.width-100,
.scroll-table td.width-100 {
  min-width: 100px;
}

.scroll-table th.width-110,
.scroll-table td.width-110 {
  min-width: 110px;
}

.scroll-table th.width-150,
.scroll-table td.width-150 {
  min-width: 150px;
}

.scroll-table th.width-120,
.scroll-table td.width-120 {
  min-width: 120px;
}

.scroll-table th.width-130,
.scroll-table td.width-130 {
  min-width: 130px;
}

.scroll-table th.width-170,
.scroll-table td.width-170 {
  min-width: 170px;
}

.scroll-table th.width-300,
.scroll-table td.width-300 {
  min-width: 300px;
}

.scroll-table th.width-200,
.scroll-table td.width-200 {
  min-width: 200px;
  max-width: 200px;
}

.scroll-table th.width-250,
.scroll-table td.width-250 {
  min-width: 250px;
}

.scroll-table th.width-350,
.scroll-table td.width-350 {
  min-width: 350px;
}

.scroll-table th.width-400,
.scroll-table td.width-400 {
  min-width: 400px;
}

.scroll-table th.width-500,
.scroll-table td.width-500 {
  min-width: 500px;
}

.scroll-table th.width-800,
.scroll-table td.width-800 {
  min-width: 800px;
}

.scroll-table th.width-1000,
.scroll-table td.width-1000 {
  min-width: 1000px;
}

.order-comments {
  max-width: 250px;
}

.order-customer-address {
  max-width: 130px;
}

.order-supplier-name {
  max-width: 150px;
}

.order-id .pop-btn-link,
.order-status .pop-btn-link,
.order-reseller-name .pop-btn-link,
.order-customer-address .pop-btn-link,
.order-comments .pop-btn-link,
.order-supplier-name .pop-btn-link {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;
  padding: 0;
}

.order-product-name {
  width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;
  padding: 0;
}

.scroll-table th,
.scroll-table td {
  padding: 5px !important;
}

.scroll-table.big-table th,
.scroll-table.big-table td {
  padding: 15px !important;
}

.filter-item {
  margin-right: 5px;
}

.margin-bottom-5 {
  margin-bottom: 5px;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-bottom-15 {
  margin-bottom: 15px;
}

.margin-bottom-30 {
  margin-bottom: 30px;
}

.form-control.order-status {
  height: 36px;
}

.date-picker input {
  height: 36px;
  width: 150px;
  padding: 0 20px 0 5px;
  text-align: center;
}

.margin-right-5 {
  margin-right: 5px;
}

.margin-right-10 {
  margin-right: 10px;
}

.padding-lr-5 {
  padding: 0 5px;
}

.padding-lr-10 {
  padding: 0 10px;
  margin-bottom: 10px;
}

.padding-lr-15 {
  padding: 0 15px;
}

.padding-lr-10px {
  padding: 0 10px;
}

.padding-lr-5px {
  padding: 0 5px;
}

#order-status-edit-popup.open {
  display: block;
}

#order-status-ordered-popup.open,
#order-status-shipped-popup.open,
#order-status-cancelled-popup.open,
#reseller-info-popup.open {
  display: block;
}

.modal-outer.open {
  display: block;
}

.popup-date-picker .react-datepicker__input-container {
  margin-bottom: 0;
}

.has-error .react-datepicker__input-container {
  margin-bottom: 0 !important;
}

.popup-date-picker .react-datepicker__input-container input {
  height: 34px;
  padding: 0 15px 0 10px;
  width: 130px;
  font-size: 14px;
}

.react-datepicker {
  font-size: 100%;
}

.border-bottom-10 {
  border-bottom: 1px solid #ddd;
}

.border-bottom-none {
  border-bottom: 0 solid #fff;
}

.order-product-photo img {
  width: 129px;
  max-height: 99px;
  object-fit: cover;
}

.order-product-photo {
  padding: 0 !important;
}

.pop-btn-link {
  text-decoration: underline;
  color: #52616a;
  font-size: 14px;
  text-transform: capitalize;
  padding-left: 0;
  padding-right: 0;
}

.order-status-edit-popup .popup-date-picker .react-datepicker__input-container {
  margin-bottom: 10px;
}

.addresse-text {
  padding-bottom: 5px;
  font-size: 15px;
}

button.pull-right:focus {
  outline: none !important;
}

.react-datepicker__input-container input[disabled] {
  background-color: #eee;
  cursor: not-allowed;
}

.form-control[disabled] {
  background-color: #eee !important;
}

.scroll-table table tr {
  position: static;
}

.scroll-table table tr .fixed-column {
  position: absolute;
  height: 100%;
  padding-top: 20px !important;
}

.overflow-hidden {
  overflow: hidden;
  position: relative;
}

.scroll-table table tr .fixed-column.order-date {
  width: 90px;
  border-right: none !important;
}

.scroll-table table tr .fixed-column.order-id {
  width: 90px;
  margin-left: 90px;
  padding-top: 25px !important;
}

.scroll-table table tbody.source_order_num_class tr .fixed-column.order-id {
  padding-top: 15px !important;
}

.scroll-table table tr .fixed-column.order-status {
  border-left: 0 solid #ddd !important;
  border-right: none !important;
  width: 100px;
  margin-left: 180px;
  height: 72px;
  padding-top: 25px !important;
  border-bottom: none !important;
}

.scroll-table table tr .fixed-column.order-verified {
  border-left: 1px solid #ddd !important;
  border-right: none !important;
  width: 100px;
  margin-left: 280px;
  padding-top: 25px !important;
}

.scroll-table table tr .fixed-column.order-reseller-name {
  width: 100px;
  margin-left: 380px;
  padding-top: 10px !important;
}

#table_head.scroll-table table tr .fixed-column.order-reseller-name {
  padding-top: 25px !important;
}

.scroll-table .order-total {
  padding-left: 485px !important;
  min-width: 570px !important;
}

.order-status .pop-btn-link {
  padding: 0;
}

.order-product-photo.width-130 {
  height: 70px;
}

.table > tbody + tbody {
  border-top: 1px solid #ddd;
}

.freeze-cover {
  position: absolute;
  left: 1px;
  height: 100%;
  bottom: 0;
  width: 480px;
  background: #fff;
  overflow: hidden;
}

.padding-30 {
  padding: 30px;
}

.padding-10 {
  padding: 10px;
}

.padding-8 {
  padding: 8px;
}

.padding-15 {
  padding: 15px;
}

.padding-tb-5 {
  padding: 5px 0;
}

.padding-tb-10 {
  padding: 10px 0;
}

.padding-tb-15 {
  padding: 15px 0;
}

.background-dark {
  background-color: #ddd;
}

.order-address-form .form-group {
  margin-bottom: 10px !important;
}

.order-address-form label {
  font-size: 14px;
  margin-bottom: 2px;
}

.order-address-form .form-control {
  padding: 3px 5px;
  font-size: 14px;
  height: 30px;
}

.shipped-color .color-background {
  background-color: #b7e1cd;
}

.cancelled-color .color-background {
  background-color: #f4c7c3;
}

.shipped-delayed-color .color-background {
  background-color: #e10d79;
}

.shipped-today-color .color-background {
  background-color: #c9302c;
}

.payment-pending-color .color-background {
  background-color: #8e7cc3;
}

.delivered-color .color-background {
  background-color: #e6e6e6;
}

.hold-order-color .color-background {
  background-color: #f9cb9c;
}

.return-exchange-color .color-background {
  background-color: #ffd966;
}

.post-status-moderated .color-background {
  background-color: lightgreen;
  color: black;
}

.post-status-non-moderated .color-background {
  background: none;
  color: black;
}

.post-status-under-review .color-background {
  background-color: lightyellow;
  color: black;
}

.post-status-blocked .color-background {
  background-color: #ff6c5c;
  color: black;
}

.order-view-reseller-name {
  padding: 8px 15px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.search-supplier .Select {
  min-width: 230px;
}

.search-supplier .Select-value,
.search-supplier .Select-menu-outer,
.search-supplier .Select-placeholder,
.search-supplier .Select-input {
  text-align: left;
}

.search-supplier .Select-placeholder {
  color: #cdcdcd;
}

.search-supplier .Select-input {
  display: block !important;
}

.colored-row .color-background .pop-btn-link {
  color: #fff;
}

.colored-row .color-background.row-text-color {
  color: #fff;
}

.white-background {
  background-color: #fff;
}

.tableFix {
  position: fixed;
  right: 15px;
  left: 216px;
  z-index: 10;
  top: 52px;
  margin-top: 0 !important;
}

#table_head th {
  background-color: #fff;
}

.table_body_margin {
  margin-top: -1px;
}

.table_body_margin_scroll {
  margin-top: 94px;
}

.z-index-max {
  z-index: 10000;
}

.height-80 {
  height: 80px !important;
}

.order-status.height-80 {
  height: 79px !important;
}

.invisible-layer {
  position: fixed;
  height: 73px;
  top: 52px;
  background-color: #fff;
  right: 15px;
  left: 215px;
  z-index: 1000;
}

#wrapper.sidebarClosed .tableFix {
  left: 16px;
}

#wrapper.sidebarClosed .invisible-layer {
  left: 15px;
}

#table_head::-webkit-scrollbar {
  width: 0;
  height: 0;
}

#table_head::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0 #fff;
}

#table_head::-webkit-scrollbar-thumb {
  background-color: #fff;
  outline: 0 solid #fff;
}

#table_body.scroll-table table tr .fixed-column.order-id {
  padding-top: 10px !important;
}

#table_body.scroll-table
table
tbody.source_order_num_class
.order-product-photo
img {
  min-height: 80px;
}

#table_body.scroll-table
table
tbody.source_order_num_class
.fixed-column.order-status {
  height: 90px;
}

.whatsapp-chat-button {
  display: block;
  padding: 10px;
  height: 40px;
  text-align: center;
  background-color: #25d366;
  border: 2px solid #25d366;
  color: #fff !important;
  background-position: center;
  background-size: 20px 20px;
  background-image: url(https://s3-ap-southeast-1.amazonaws.com/meesho-static-test/css/img/ic_whatsapp.png);
  background-repeat: no-repeat;
}

.filter-item .Select {
  min-width: 50px;
  width: auto;
  display: inline-block;
  margin: 0;
  vertical-align: middle;
}

.filter-item .Select-placeholder {
  color: #cdcdcd;
}

.order-filter .date-picker input {
  width: 110px;
  height: 32px;
}

.table-content {
  margin-top: 20px;
}

.filter-block {
  padding: 3px;
  margin-bottom: 3px;
}

.order_number_filter {
  width: 100px;
  padding: 0 20px 0 3px;
  height: 32px;
  outline: none !important;
}

.reseller_code_filter {
  width: 200px;
  padding: 0 20px 0 3px;
  height: 32px;
  outline: none !important;
}

.customer-number-filter {
  width: 100px;
}

.filter-item .Select-placeholder,
.filter-item .Select--single > .Select-control .Select-value {
  position: relative;
  padding-right: 30px;
}

.filter-item .Select-clear-zone {
  position: absolute;
  top: 7px;
  right: 15px;
}

.filter-item .Select-arrow-zone {
  position: absolute;
  top: 15px;
  right: -5px;
}

.filter-item .Select-input {
  position: absolute;
  top: 0;
}

.filter-item .Select-control {
  width: auto;
  min-width: 100px;
}

.filter-submit {
  padding-left: 25px;
  padding-right: 25px;
  outline: none !important;
  border-radius: 0;
}

.order-date-filter.has-error {
  color: #a94442;
  border-color: #a94442;
}

.add-clear-x {
  cursor: pointer;
  position: absolute;
  pointer-events: auto;
  right: 0;
  top: 0;
  z-index: 100;
  font-size: 18px;
}

.supplier-filter .Select {
  min-width: 120px !important;
}

.supplier-filter .Select-control {
  min-width: 120px !important;
}

.supplier-filter .Select-input {
  min-width: 120px;
}

.supplier-filter .Select-menu-outer {
  min-width: 120px !important;
}

.Select-menu-outer {
  z-index: 1000000;
}

.filter-hide-button {
  background-color: #fff;
  border-radius: 4px;
  padding: 4px 15px;
  display: inline-block;
  vertical-align: middle;
  outline: none !important;
}

.booking-details-product-image img {
  max-width: 100%;
  max-height: 100px;
  object-fit: cover;
}

.popup-sub-heading {
  padding-bottom: 5px;
}

ul.pagination {
  margin: 8px 0;
}

.shipping_time_inputs .shipping_time_start {
  display: inline-block;
  vertical-align: middle;
  margin: 10px 5px;
}

.shipping_time_start input {
  width: 40px;
  padding: 0 3px;
  height: 30px;
  text-align: center;
}

.shipping_time_date input {
  width: 105px;
  padding: 0 5px;
  height: 30px;
}

.supplier-add-shipping-time.width-150 {
  padding: 0 !important;
}

.product_upload_failed .product-details {
  background-color: #d07079;
}

.product_taxonomy_failed .product-taxonomy-details {
  background-color: #d07079;
}

.product_taxonomy_success .product-taxonomy-details {
  background-color: #a1de9a;
}

.product_upload_success .product-details {
  background-color: #a1de9a;
}

.verified-filter-dropdown {
  width: 80px;
}

.exchange_supplier_status-dropdown {
  width: 120px;
}

.return-filter-dropdown {
  width: 120px;
  padding: 0 5px;
}

.filter-dropdown {
  width: auto;
}

.catalog-supplier {
  padding: 5px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #fff;
  z-index: 100;
}

.catalog-supplier-name {
  padding: 5px 10px;
  margin: 5px 3px;
  color: #fff;
  border-radius: 2px;
  background-color: #93a4af;
}

.width-50-per {
  width: 50%;
}

.catalog-notification-schedule-popup .modal-inner {
  max-width: 500px;
}

.catalog-notification-schedule-popup .modal-inner.deactiveted-catalog {
  max-width: 750px;
  width: 750px;
}

.padding-right-0 {
  padding-right: 0;
}

.padding-left-0 {
  padding-left: 0;
}

.padding-right-10 {
  padding-right: 10px;
}

.padding-zero {
  padding: 0;
}

.vertical-align-top {
  vertical-align: top;
}

.catalog-container.col-md-3 {
  padding: 0 5px;
}

.color-back-text {
  background-color: #fff;
  padding: 0 10px 5px;
  color: #c66;
  margin: 0 -5px;
}

.has-selected {
  border: 1px solid #00f;
  color: #00f;
}

.particle-container {
  height: calc(100vh - 50px);
  margin: 0;
}

.flex-container {
  display: -webkit-flex;
  -webkit-align-items: center;
  display: flex;
  align-items: center;
}

.flex-container .item1 {
  -webkit-flex: 1;
  flex: 1;
}

.price-range-filter input {
  width: 100px;
  height: 30px;
  padding: 0 5px;
}

.catalog-type-filter select {
  width: 100px;
  height: 34px;
  padding: 0 5px;
  display: inline-block;
}

.price-range-filter .add-clear-x {
  top: 0;
  right: 0;
}

.filter-block.has-error {
  border: 1px solid #a94442;
}

.filter-item .Select--multi .Select-control {
  min-width: 150px;
  padding-right: 50px;
}

.filter-item .Select--multi.Select {
  min-width: 150px;
}

.Select--multi .Select-value-label {
  padding: 5px;
}

.date-selected {
  border: 1px solid #00f;
}

.CatalogNameSearch {
  width: 200px;
}

.aa-input {
  background: #fff !important;
  height: 34px;
  border: 1px solid #c9d6de !important;
}

.aa-input:focus {
  outline: none !important;
}

#vertical_scrolling_div .order-timeline-list td {
  padding: 10px !important;
  height: auto !important;
  color: #fff;
  font-size: 14px;
}

.timeline-message {
  background-color: #f26c63 !important;
}

.timeline-time {
  background-color: #3c5764 !important;
  width: 150px;
}

textarea {
  resize: vertical;
}

.order-timeline-list {
  color: #fff !important;
}

.payment-screen-shot .modal-inner {
  transition: all 0.5s ease;
}

.payment-screen-shot.zoomin .modal-inner {
  max-width: 800px;
  width: 800px;
}

.screenshot-image img {
  cursor: zoom-in;
  width: 100%;
}

.payment-screen-shot.zoomin img {
  cursor: zoom-out;
}

.form-group .aa-hint,
.form-group .aa-input {
  display: block;
  width: 100%;
  height: 34px;
  font-size: 14px;
  line-height: 1.42857;
  color: #555;
  background: #fff none;
  padding: 6px 0;
  border-image: initial;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 0;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  border: 1px solid #c9d6de;
  box-shadow: none !important;
}

.form-group .CatalogNameSearch {
  width: 100%;
}

.has-error #catalog-name-search {
  border: 1px solid #a94442 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.form-group .aa-input:focus {
  border: 1px solid #0f213c !important;
}

#scroll-table-content .order-timeline-list td {
  height: auto;
  padding: 10px;
}

#scroll-table-content .order-timeline-list th {
  height: auto;
  padding: 10px;
}

#scroll-table-content .order-timeline-list .table-border-none th {
  border: none !important;
  text-align: left;
  padding: 10px 0;
}

#scroll-table-content .order-timeline-list .table-border-none td {
  border: none !important;
  text-align: left;
}

.column-width-180 {
  width: 180px;
}

.catalog-supplier-products-info {
  margin-bottom: 40px;
}

.img-max-200 {
  width: 200px;
}

.catalog-supplier-products-info table {
  margin-bottom: 0;
}

.catalog-supplier-products-info .w-100 {
  width: 100px;
}

.catalog-supplier-products-info .w-150 {
  width: 150px;
}

.catalog-supplier-products-info .padding-zero {
  padding: 0 !important;
}

.catalog-supplier-products-info .w-200 {
  width: 200px;
}

.catalog-supplier-products-info .w-170 {
  width: 180px;
}

.button-2,
.button-2:focus {
  background-color: #b84b9e;
  border-color: #b84b9e;
  outline: none !important;
}

.button-2:hover,
.button-2:active {
  background-color: #933c7e;
  border-color: #933c7e;
}

.button-3,
.button-3:focus {
  background-color: #93228d;
  border-color: #93228d;
  padding: 10px 30px;
  outline: none !important;
}

.button-3:hover,
.button-3:active {
  background-color: #751b70;
  border-color: #751b70;
}

.button-4,
.button-4:focus {
  background-color: #c83652;
  border-color: #c83652;
  padding: 10px 30px;
  outline: none !important;
}

.button-4:hover,
.button-4:active {
  background-color: #b43049;
  border-color: #b43049;
}

.rd-width-300 {
  width: 300px;
}

.rd-width-200 {
  width: 180px;
}

.padding-20 {
  padding: 20px;
}

.background-grey {
  background: #e5e5e5;
}

.catalog-supplier-products-info:last-child {
  margin-bottom: 0;
}

.catalog-order-cta .alert {
  margin: 0;
  border-radius: 0;
  padding: 10px;
}

.order-cancel-details div:last-child {
  max-height: 60px;
  overflow: hidden;
}

.order-text-flag,
.order-change-supplier {
  display: none;
}

.payment-screen-shot .modal-content {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
}

#catalog-info-edit label {
  display: inline-block;
}

.control-label {
  margin-bottom: 5px;
}

#catalog-info-edit input[type="checkbox"],
input[type="radio"] {
  margin-bottom: 0;
  margin-top: 2px;
}

.reseller-input-search {
  width: auto;
  min-width: 250px;
  height: 35px;
  font-size: 14px;
  outline: none !important;
  padding: 0 25px 0 5px;
  border: 1px solid #c9d6de;
}

.reseller-input-search:focus {
  border: 1px solid #888;
}

.reseller_search_result {
  position: absolute;
  background-color: #fff;
  z-index: 10;
  width: 250px;
  right: 0;
  font-size: 14px;
}

.catalog_search_result {
  width: 100%;
}

.reseller_search_result ul {
  border: 1px solid #c9d6de;
  border-top: none;
  padding: 0;
  max-height: 200px;
  overflow-y: scroll;
}

.reseller_search_result ul:empty {
  display: none;
}

.reseller_search_result ul li {
  padding: 7px;
  cursor: pointer;
}

.reseller_search_result ul li:hover {
  background-color: #ededed;
}

.ResellerNameSearch .add-clear-x {
  right: 0;
  top: 0;
}

#unsubscribeView {
  width: 100%;
  min-height: 100vh;
}

#unsubscribeView .panel-heading {
  padding: 15px 10px;
  background-color: #fff;
}

#unsubscribeView .panel-title {
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  line-height: 24px;
}

#unsubscribeView .panel-body {
  padding: 15px 0;
}

.padding-top-2em {
  padding-top: 2em;
}

.padding-top-6 {
  padding-top: 6px;
}

.unsubscribe-heading {
  color: rgb(159, 32, 137);
  padding: 30px 10px 10px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
}

.unsubscribe-form {
  max-width: 430px;
  padding: 60px 10px 10px;
  margin: 0 auto;
}

.unsubscribe-button {
  padding: 10px 40px;
}

.unsubscribe-error {
  margin: 15px 0 0;
}

.card {
  will-change: transform;
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  -webkit-transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
  box-shadow: 0 27px 55px 0 rgba(0, 0, 0, 0.3),
  0 17px 17px 0 rgba(0, 0, 0, 0.15);
}

.unsubscribe-button {
  margin: 0 10px;
  padding: 10px 0;
  width: 120px;
  color: #fff !important;
  font-weight: 700;
}

.unsubscribe-no {
  background-color: #36486b;
}

.unsubscribe-yes {
  background: transparent;
  color: #444 !important;
  border: 1px solid #b2c2bf;
}

.success-message-heading {
  color: #e06377;
}

.descriptionControl {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.descriptionPopup .modal-inner {
  max-width: 600px;
}

.supplier-data-table {
  max-height: calc(100vh - 100px);
  min-height: 300px;
  width: 100%;
  overflow: auto;
  border: 1px solid #c9d6de;
  background-color: #ffffff;
}

.supplier-data-table table {
  margin-bottom: 0;
}

.btn-google-sign-up .fa {
  display: inline-block;
  vertical-align: middle;
  line-height: 34px;
  font-size: 1.6em;
  text-align: center;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  padding: 5px 15px 5px 10px;
  width: 60px;
}

.btn-google-sign-up {
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  color: #fff;
  width: 100%;
  text-align: left;
  background-color: #c23321;
  border-color: rgba(0, 0, 0, 0.2);
  padding: 0;
}

.btn-google-sign-up:hover,
.btn-google-sign-up:active,
.btn-google-sign-up:focus {
  color: #fff;
  background-color: #a32b1c;
  border-color: rgba(0, 0, 0, 0.2);
}

.btn-google-sign-up span {
  width: 220px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.full-page {
  margin: 0;
  height: calc(100vh - 50px);
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-flow: column;
}

.googleLoginButton {
  width: 280px;
}

.display-block {
  display: block;
}

.fixed_headers {
  max-width: 1690px !important;
  width: 1690px !important;
  border-collapse: collapse;
}

.fixed_headers thead {
  display: block;
  width: 1690px;
  overflow: auto;
}

.fixed_headers tbody {
  display: block;
  width: 1690px;
  height: 300px;
  overflow: auto;
}

#supplierlistdeleted .supplier-data-table {
  max-height: calc(100vh - 150px);
}

.catalog_trend {
  font-size: 14px;
  color: #555;
}

.catalog_trend .Select-placeholder {
  color: #888;
  font-size: 14px;
}

.clockpicker.form-control {
  border-left: 0;
}

.variation-popup .modal-inner {
  max-width: 1000px !important;
  width: 1000px !important;
}

.right {
  float: right;
}

.orderCount {
  color: white;
  margin-top: 15px;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: calc(50% - 200px);
  width: 400px;
  text-align: center;
}

.img-height-150 {
  max-height: 150px;
  width: 100%;
  object-fit: cover;
}

.passbook-photo {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
  cursor: zoom-in;
}

.fixed-header {
  table-layout: fixed;
}

/*.fixed-header tbody {display: block;overflow: auto;width: 100%;height: 300px;}*/
.payment-button button {
  padding: 7px 20px;
  margin: 0 5px;
}

#bank_details_reseller_search {
  width: 315px;
  font-size: 14px;
}

#bank_details_reseller_search .reseller_search_result ul {
  padding: 0;
}

#bank_details_reseller_search .reseller-input-search {
  width: 200px;
  height: 35px;
  padding: 0 25px 0 5px;
}

#bank_details_reseller_search .reseller_search_result {
  width: 200px;
  right: 1px;
}

#bank_details_reseller_search.ResellerNameSearch .add-clear-x {
  width: 25px;
  right: 1px;
  top: -10px;
}

.referral-details-page
#bank_details_reseller_search.ResellerNameSearch
.add-clear-x {
  top: -8.5px;
}

.bank_details_popup_name {
  max-width: 360px;
  margin: auto;
}

.return-image-upload {
  margin-top: 15px;
}

.exchange-image-upload {
  max-width: 640px;
  margin: 20px auto 20px;
}

.padding-zero-td {
  padding: 0 !important;
}

input.max-width-50 {
  max-width: 50px !important;
  padding: 0 5px;
}

input.max-width-70 {
  max-width: 70px !important;
  padding: 0 5px;
}

.uploaded-image-view {
  width: 140px;
  height: 120px;
  margin: auto;
}

.uploaded-image-view .product-uploaded-image-cross {
  right: 15px;
}

.product-uploaded-image {
  height: 120px;
}

.emptyPicContainer {
  position: relative;
  width: 120px;
  height: 120px;
  /* margin: auto; */
  overflow: hidden;
  cursor: pointer;
}

.emptyPic {
  margin: auto;
  position: relative;
  padding-top: 28px;
  text-align: center;
  width: 120px;
  height: 120px;
  border: 1px solid #ededed;
  border-bottom-width: 3px;
  border-left-width: 2px;
  cursor: pointer;
  opacity: 0.9;
  color: #888888;
  overflow: hidden;
}

.emptyPic input[type="file"] {
  display: block;
}

.fileIcon {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}

.emptyFileContainer {
  position: relative;
  width: 150px;
  height: 60px;
  margin: auto;
  overflow: hidden;
  cursor: pointer;
}

.emptyFile {
  padding: 10px 0;
  text-align: center;
  width: 150px;
  border: 1px solid #ededed;
  border-bottom-width: 3px;
  border-left-width: 2px;
  cursor: pointer;
  opacity: 0.9;
  color: #888888;
  overflow: hidden;
}

.disableCursor {
  cursor: not-allowed !important;
}

.uploaded-file-view {
  min-width: 450px;
  margin: auto;
}

.uploaded-file-view > button {
  text-align: center;
  margin: 0 20px;
}

.review-video-update-popup .uploaded-file-view {
  min-width: auto;
}

.review-video-update-popup .review-image-box {
  width: calc(35% - 10px);
}

.review-video-update-popup .emptyFileContainer {
  width: auto;
  height: auto;
  padding: 10px 0;
}

.review-video-update-popup .emptyFile {
  margin: 0 auto;
}

.review-video-update-popup .youtube-url-input {
  display: inline-block;
  width: calc(100% - 70px);
}

.review-video-update-popup .youtube-url-btn {
  float: right;
  width: 70px;
}

.uploaded-file-view .uploaded-file-cross {
  right: 15px;
}

.return-initiate-block {
  max-width: 480px;
  margin: auto;
}

.exchange_dispatch_date .react-datepicker__input-container {
  margin-bottom: 0 !important;
}

.filter-container {
  padding: 10px;
  background-color: #ffffff;
}

#scroll-table-content {
  background-color: #ffffff;
}

.no-margin {
  margin: 0 !important;
}

.order-filter {
  margin-top: 5px;
  padding-bottom: 10px;
}

.Select-placeholder,
.Select--single > .Select-control .Select-value {
  line-height: 30px;
}

.Select-input {
  height: 30px;
}

.Select-control {
  height: 32px;
}

.firebase-admin-view .Select-control {
  height: 38px;
}

.firebase-admin-view .Select-placeholder,
.firebase-admin-view .Select--single > .Select-control .Select-value {
  line-height: 38px;
}

.filter-item .form-control {
  height: 32px;
}

.form-control-feedback {
  width: 30px;
  height: 35px;
  line-height: 35px;
}

.filter-block input[type="checkbox"] {
  margin-top: 0;
}

.filter-select-box {
  max-width: 120px;
  padding: 0 5px;
  font-size: 12px;
  min-width: 50px;
}

.aa-input {
  height: 32px;
}

.Select--multi .Select-value {
  margin: 3px 1px 3px;
}

.modal-footer button,
.popup-cta button {
  border-radius: 0;
  min-width: 110px;
}

.delete-block {
  width: 480px;
  margin: 0 auto;
}

.remove-act-schedule_date button {
  width: 110px;
  border-radius: 0;
  height: 40px;
}

input {
  outline: none !important;
}

.remove-act-schedule_date {
  margin-top: 15px;
}

.catalog-edit-action a {
  border-radius: 0 !important;
}

.corner-ribbon {
  font-size: 12px;
  width: 80px;
  background: #e43;
  position: absolute;
  text-align: center;
  line-height: 20px;
  letter-spacing: 1px;
  color: #f0f0f0;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.corner-ribbon.top-left {
  top: 10px;
  left: -12px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.corner-ribbon.red {
  background: #e43;
}

.ribbon {
  position: absolute;
  z-index: 1;
  overflow: hidden;
  width: 150px;
  height: 150px;
  text-align: right;
}

.ribbon.left-ribbon {
  left: 0;
  top: 0;
}

.ribbon.right-ribbon {
  right: -5px;
  top: -5px;
}

.ribbon span {
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  width: 100px;
  display: block;
  background: linear-gradient(#ee4433 0%, #e43 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
}

.ribbon.left-ribbon span {
  top: 19px;
  left: -21px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.ribbon.right-ribbon span {
  top: 19px;
  right: -21px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.ribbon span::before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
}

.ribbon.left-ribbon span::before {
  border-left: 3px solid #e43;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #e43;
}

.ribbon.right-ribbon span::before {
  border-left: 3px solid #e43;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #e43;
}

.ribbon span::after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
}

.ribbon.left-ribbon span::after {
  border-left: 3px solid transparent;
  border-right: 3px solid #e43;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #e43;
}

.ribbon.right-ribbon span::after {
  border-left: 3px solid transparent;
  border-right: 3px solid #e43;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #e43;
}

.catalog-view-image .ribbon.left-ribbon span,
.banner-image .ribbon.left-ribbon span {
  top: 15px;
  left: -23px;
  line-height: 25px;
  font-size: 14px;
  background: #9F2089;
}

.catalog-view-image .ribbon.right-ribbon,
.banner-image .ribbon.left-ribbon {
  width: 105px;
  height: 105px;
}

.catalog-view-image .ribbon.right-ribbon span {
  top: 23px;
  right: -30px;
  line-height: 30px;
  font-size: 10px;
  width: 135px;
}

.catalog-view-image .ribbon.left-ribbon span::before,
.banner-image .ribbon.left-ribbon span::before {
  border-left: 3px solid #456990;
  border-top: 3px solid #456990;
}

.catalog-view-image .ribbon.left-ribbon span::after,
.banner-image .ribbon.left-ribbon span::after {
  border-right: 3px solid #456990;
  border-top: 3px solid #456990;
}

.button-deleted-flag {
  position: relative;
  z-index: 1;
}

#table-content {
  padding: 0 10px;
}

.supplier-product-table {
  width: 100%;
  overflow: auto;
  border: 1px solid #c9d6de;
}

.supplier-product-table table {
  margin-bottom: 0;
}

.compute-price {
  padding: 10px 15px;
  margin-top: 12px;
}

.btn-medium {
  width: 150px;
  padding: 8px 10px;
  border-radius: 0;
  font-weight: bold;
}

.gst_rate_dropdown {
  width: auto;
  min-width: 120px;
  display: inline-block;
  padding: 0 5px;
}

.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.product-image-zoom-box {
  max-height: 100px !important;
  overflow: hidden;
}

.product-row-content .product-image-zoom-box {
  max-height: 120px !important;
}

.product-image-zoom,
.product-image-2 {
  cursor: pointer;
  transition: all 0.2s ease;
}

.product-image-zoom.zoom-in {
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
}

.product-image-zoom.zoom-in .product-image-2 {
  max-width: 500px !important;
  max-height: calc(100vh - 100px);
  margin-top: 50px;
  object-fit: contain;
}

.body-scroll-hidden {
  overflow: hidden;
}

.margin-right-30 {
  margin-right: 30px;
}

.product-row-content .product-image-zoom.zoom-in .product-image-2 {
  max-height: calc(100vh - 100px);
  height: auto !important;
}

.payment-details-table th {
  border: none !important;
  text-align: left !important;
  padding: 5px 0 !important;
  font-size: 14px !important;
}

.payment-details-table td {
  border: none !important;
  text-align: left !important;
  padding: 5px 0 !important;
}

.payment-table-order-num {
  background-color: #f9f9f9;
}

.payment_details_sub_rows .col-lg-4 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.payment-table-order-num {
  margin-bottom: 20px;
}

.payment-table-order-num:last-child {
  margin-bottom: 0;
}

.no-payment-found {
  margin-top: 35px;
}

.dark-background {
  background-color: #d4d2d2;
}

.pop-up-max-height {
  max-height: calc(100% - 70px);
  overflow-y: auto;
}

.paste-zone {
  min-height: 100px;
  cursor: cell;
  background-color: #ffffff;
}

.selected-tags {
  color: #fff;
  border-radius: 16px;
  display: inline-block;
  vertical-align: middle;
  background-color: #305ae3;
  font-size: 14px;
  margin: 5px 10px 5px 0;
  -webkit-transition: all 5s;
  transition: all 5s;
  cursor: pointer;
}

.selected-tag-cross {
  padding: 0 18px 0 10px;
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  line-height: 34px;
  font-weight: bold;
  margin-top: -5px;
}

.selected-tags-name {
  padding: 7px 0 7px 18px;
  display: inline-block;
  vertical-align: middle;
}

.selected-tags:hover {
  background: #4f73e7;
}

.search-catalog-selection {
  padding: 10px 0;
}

.search-catalog-selection .add-clear-x {
  top: 0;
}

.collection_search_result {
  position: absolute;
  background-color: #fff;
  width: 100%;
  left: 0;
  display: none;
  z-index: 1;
}

.collection_search_result ul {
  border: 1px solid #c9d6de;
  max-height: 200px;
  overflow-y: scroll;
}

.collection_search_result ul:empty {
  display: none;
}

.collection_search_result ul li {
  padding: 7px;
  cursor: pointer;
}

.collection_search_result ul li:hover,
.collection_search_result ul li.selected {
  background-color: #ededed;
}

.collection_search_result ul li[disabled] {
  background-color: #eee !important;
  cursor: not-allowed;
}

.collection_search_result.visible {
  display: block;
}

.collection-image {
  width: 100%;
  max-height: 150px;
  object-fit: contain;
}

.collection-view-left .product-image-zoom.zoom-in .collection-image {
  margin-top: 52px;
  max-height: calc(100vh - 100px);
  height: auto !important;
  max-width: 512px !important;
  width: auto !important;
}

#collection-info-view {
  width: 600px;
  margin: 30px auto 0;
}

.border-red {
  border-color: #a94442;
}

.compute-price-warning .modal-inner {
  max-width: 680px;
  width: 500px;
}

.compute-price-warning-proceed .modal-inner {
  max-width: 580px;
  width: 580px;
}

.add-new-referral .modal-inner {
  max-width: 780px;
  width: 780px;
}

.referred-details-popup .modal-inner {
  max-width: 1220px;
  width: 1220px;
}

.referred-fraud-popup .modal-inner {
  max-width: 600px;
  width: 600px;
}

.markup_price_error_row td {
  color: #a94442 !important;
  border: 2px solid #ebccd1 !important;
}

.collection_search_filter {
  right: -1px;
  left: auto;
  width: 150px;
  top: 100%;
  z-index: 100;
}

.collection_search_filter ul {
  border-top: none;
}

.collection_search_filter li {
  line-height: 1;
}

.collection_search_filter ul li {
  line-height: 1;
  padding: 10px 8px;
}

.panel-info-light .panel-heading {
  background-color: #e0f0f8;
  color: #5a8ca5;
}

.supplier-add-edit-container {
  margin: 0 auto;
  width: 900px;
}

.supplier-add-edit-container .control-label {
  font-size: 14px;
}

.supplier-add-edit-container .help-block {
  font-size: 14px;
}

.private-label-supplier .Select {
  margin: 0;
}

.private-label-supplier {
  width: 200px;
}

.sorting-container {
  font-size: 14px;
  margin-top: 10px;
}

.sorting-container span {
  color: #212121;
  font-weight: bold;
  padding: 7px 0 4px 0;
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;
  border-bottom: 2px solid transparent;
}

.sorting-container ul {
  display: inline-block;
  vertical-align: middle;
}

.sorting-container ul li {
  display: inline-block;
  vertical-align: middle;
  padding: 7px 0 4px;
  margin: 0 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.sorting-container ul li.active-sort {
  color: #2196f3;
  border-bottom: 2px solid #2196f3;
  font-weight: bold;
}

.catalog-s-o-count {
  position: absolute;
  background-color: #456990;
  color: #fff;
  bottom: 0;
  padding: 10px 5px;
  width: 100%;
  text-align: center;
}

.catalog-more-button {
  outline: none !important;
  width: 100%;
  background: #9F2089;
  color: #fff !important;
  font-weight: bold;
  padding: 10px 5px;
  border-radius: 0;
}

.catalog-more-button:hover {
  background-color: #9F2089;
}

.catalog-more {
  overflow: hidden;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.fixed-action-btn ul {
  width: 200%;
  left: -100%;
  right: 0;
  text-align: center;
  position: absolute;
  bottom: 42px;
  margin: 0;
  visibility: visible;
  background: #ffffff;
}

.fixed-action-btn ul li {
  margin-bottom: 15px;
  width: 50%;
  float: right;
}

.fixed-action-btn ul li:last-child {
  margin-bottom: 0;
}

.fixed-action-btn ul button,
.fixed-action-btn ul a {
  transform: scaleY(0.4) scaleX(0.4) translateY(40px) translateX(0px);
  opacity: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  cursor: pointer;
}

.fixed-action-btn.active-button ul button,
.fixed-action-btn.active-button ul a {
  outline: none !important;
  opacity: 1;
  transform: scaleY(1) scaleX(1) translateY(0px) translateX(0px);
}

.fixed-action-btn.active-button .catalog-more {
  overflow: visible;
}

.fixed-action-btn.active-button ul {
  visibility: visible;
}

#payment_timeline-table {
  margin-bottom: 0;
}

#payment_timeline-table th {
  padding: 10px 8px !important;
}

#payment_timeline-table td {
  text-align: left !important;
  padding: 20px 8px;
}

#payment_timeline-table td.text-center {
  text-align: center !important;
}

.auto-height-row th,
.auto-height-row td {
  height: auto !important;
  padding: 10px 5px !important;
}

.addressEnableHiddenButton {
  position: fixed;
  bottom: 0;
  right: 0;
  border-radius: 0;
  height: 40px;
  opacity: 0;
}

.algolia-autocomplete .aa-dropdown-menu {
  z-index: 1000 !important;
}

.has-error span {
  color: #a94442;
}

.inline-element {
  display: inline-block;
  vertical-align: top;
  padding-right: 5px;
  margin-right: 5px;
  border-right: 1px solid #888;
}

.btn {
  outline: none !important;
}

.bonus-details {
  max-width: 1020px;
  width: 1020px;
}

.bonus-details .panel-body {
  padding: 10px;
}

.bonus-details .col-md-4 {
  padding-left: 0;
  padding-right: 0;
}

.bonus-details .col-md-4 .panel-body {
  padding: 0;
}

.bonus-details .row {
  margin-left: 0;
  margin-right: 0;
}

.bonus-details th,
.bonus-details td {
  padding: 8px 5px !important;
}

.bonus-details .btn-link {
  padding: 0 10px;
  display: inline-block;
  vertical-align: middle;
}

.bonus-card-head {
  background-color: #adc9e2;
}

.bonus-details .panel-heading {
  letter-spacing: 1.3px;
  font-size: 14px;
}

.return-details td,
.return-details th {
  padding: 10px 5px !important;
}

.exchange-details td,
.exchange-details th {
  padding: 10px 5px !important;
}

.image-zoom {
  cursor: pointer;
}

.avif-image {
  cursor: pointer;
}

.order-exchange-popup .action-cta {
  padding: 10px 5px;
}

.right-div {
  position: absolute;
  right: 10px;
  top: 10px;
}

.r-e-product-image img {
  max-width: 100%;
  max-height: 180px;
}

.r-e-product-info {
  padding-bottom: 10px;
}

.reseller-buttons .col-md-2 {
  width: 16.666% !important;
}

.reseller-buttons .col-md-2:nth-child(even) {
  padding: 0;
}

.reseller-buttons .col-md-2:last-child {
  padding-right: 15px;
}

.resellar-referral-details {
  margin-top: 35px;
}

.view-buttons {
  margin: 0 10px;
  border-radius: 0;
  min-width: 80px;
}

.referral-details {
  margin-bottom: 30px;
}

.banner-container {
  margin-bottom: 30px;
  font-size: 14px;
  text-align: center;
}

.single-banner-content.deactivated-banner .banner-container {
  background-color: #c9d6de;
}

.banner-image img {
  width: 100%;
  object-fit: contain;
  max-height: 150px;
}

.app-banners {
  margin-left: -10px;
  margin-right: -10px;
}

.app-banners .col-lg-3 {
  padding-left: 10px;
  padding-right: 10px;
}

.clock-picker .form-group {
  margin-bottom: 0;
}

.has-error input,
.has-error .Select-control {
  border: 1px solid #a94442;
}

.single-banner-content {
  float: none;
  display: inline-block;
  vertical-align: top;
}

.no-banner-found {
  font-size: 16px;
  margin: 10px 0 20px;
  padding: 20px;
  border: 1px solid #c9d6de;
  background-color: #ffffff;
}

.banners-heading {
  padding: 15px 10px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
}

.banners-heading-inner {
  position: relative;
  display: inline-block;
}

.banners-heading-inner:before {
  content: "";
  top: 14px;
  position: absolute;
  right: calc(100% + 10px);
  border: 2px solid #c9d6de;
  width: 100px;
}

.banners-heading-inner:after {
  content: "";
  top: 14px;
  position: absolute;
  left: calc(100% + 10px);
  border: 2px solid #c9d6de;
  width: 100px;
}

.scary-view {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 10000;
}

.scary-view img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.error-text {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  padding: 7px 10px;
  font-size: 14px;
  text-align: center;
}

.box-shadow {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
}

.fraud-table-view {
  /*max-height: calc(100vh - 150px);*/
  width: 100%;
  overflow: auto;
  border: 1px solid #c9d6de;
}

.referral-table-view {
  width: 100%;
  overflow: auto;
  border: 1px solid #c9d6de;
}

.error-message {
  font-weight: bold;
  text-align: center;
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  padding: 10px 30px;
  margin-top: 10px;
}

.warning-message {
  font-weight: bold;
  text-align: center;
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
  padding: 10px 30px;
  margin-top: 0;
}

.success-message {
  font-weight: bold;
  text-align: center;
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  padding: 10px 30px;
  margin-top: 10px;
}

.plan-details {
  border: 1px solid #c9d6de;
  border-top: 0;
}

.plan-heading {
  background-color: #c9d6de;
  padding: 10px;
  font-weight: bold;
}

.plan-body {
  padding: 10px;
}

.plan-body th {
  padding: 10px 5px !important;
}

.plan-details-button button {
  padding: 10px;
  border-radius: 0;
  position: relative;
  transition: all 0.5s ease;
}

.plan-details-button .btn-group:nth-child(2) button {
  border-left: none;
  border-right: none;
}

.plan-details-button button.active_view {
  background-color: #eb4e85;
  color: #ffffff;
  font-weight: bold;
  border-color: #eb4e85;
}

.plan-details-button button.active_view::after {
  content: "";
  position: absolute;
  top: 100%;
  left: calc(50% - 10px);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #eb4e85;
}

.referral-plan-orders,
.referral-plan-payments {
  max-height: 300px;
  overflow: auto;
  transition: all 0.5s ease;
}

.referral-filter {
  margin-bottom: 20px;
}

.referral-filter-inline {
  display: inline-block;
  vertical-align: middle;
  padding-right: 15px;
}

.referral-filter label {
  padding-right: 5px;
  margin-bottom: 0;
  vertical-align: middle;
}

.referral-filter select {
  vertical-align: middle;
  display: inline-block;
  border: 1px solid #c9d6de;
  padding: 5px;
  width: 80px;
}

.referral-filter .selected_filter {
  color: #90111a;
}

.referral-filter .selected_filter select {
  border-color: #90111a;
}

.referral-filter button {
  border-radius: 0;
  padding: 5px 15px;
  min-width: 80px;
}

.compute-price-warning ul {
  padding: 0 20px;
  list-style: disc;
}

.compute-price-warning ul li {
  padding-top: 5px;
}

.cod-upload-file .emptyFileContainer {
  width: 450px;
  height: 150px;
  background-color: #ffffff;
}

.cod-upload-file .emptyFile {
  padding: 25px 0;
  width: 450px;
  height: 150px;
}

.cod-upload-file .emptyFile .fa {
  font-size: 24px;
}

.cod-upload-file .uploaded-file-view {
  border: 1px solid #c9d6de;
  padding: 53px 0;
  text-align: center;
  width: 500px;
  margin: 0 auto;
}

.upload-file-response {
  position: relative;
  padding-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}

.file-view-button {
  min-width: 100px;
}

.row-alert {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  font-weight: bold;
}

.download-response-file {
  position: absolute;
  right: 0;
  bottom: 5px;
}

.download-response-file button {
  display: inline-block;
  background: #3f51b5;
  border: 1px solid #3f51b5;
  padding: 8px 12px;
  border-radius: 2px;
  color: #fff !important;
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1.5px;
  transition: all 0.5s ease;
}

.download-response-file button:hover {
  background: #283593;
  border: 1px solid #283593;
  outline: none;
}

.order-related-editing div[class^="col-md-"] {
  background-color: #ffffff;
}

.edit-heading {
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 20px;
}

.edit-email-button {
  margin-top: 27px;
}

.edit-email-button button {
  padding: 6px 30px;
  border-radius: 0;
}

.Select-input > input {
  border: none;
}

.page-links {
  display: inline-block;
  vertical-align: middle;
  margin: 0 15px 15px 0;
  padding: 8px 20px;
  font-weight: bold;
  border-radius: 0;
  min-width: 120px;
}

.tasks-button {
  font-weight: bold;
  min-width: 120px;
  padding: 8px 20px;
  margin-right: 15px;
}

.date-input input {
  width: 100%;
  height: 34px;
  border-radius: 0;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  border: 1px solid #c9d6de;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
}

.page-loader {
  margin: 0;
  height: 100vh;
}

#pinterest-columns {
  column-width: 320px;
  column-gap: 15px;
}

#pinterest-columns .form-group {
  background: #fefefe;
  border: 2px solid #fcfcfc;
  margin: 0 2px 5px;
  padding: 5px 5px 10px;
  transition: opacity 0.4s ease-in-out;
  column-break-inside: avoid;
}

#pinterest-columns label,
#pinterest-columns input {
  margin: 0 !important;
}

.index-page-links {
  margin-top: 40px;
  text-align: center;
}

.index-page-links ul li {
  display: inline-block;
  margin: 0 10px 20px;
}

.index-page-links ul li a {
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: ; */
  color: rgb(159, 32, 137);
  text-decoration: none !important;
  padding: 10px 20px;
  border: 1px solid rgb(159, 32, 137);
  border-radius: 4px;
}

.index-page {
  padding: 40px;
}

.table-scrollable {
  width: 100%;
  overflow: auto;
  border: 1px solid #c9d6de;
  background-color: #ffffff;
}

.payment_status_yellow_color {
  background-color: #fecc0c;
  color: #555555;
}

.payment_status_red_color {
  color: #a94442;
  background-color: #f2dede;
}

.sync-users-button {
  margin-bottom: 10px;
}

.user-name {
  padding: 14px 15px;
}

.user-email {
  margin-bottom: 0;
  font-size: 14px;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.logout {
  color: #e11900;
}

/* Roles Dropdown Styles */
.roles-dropdown-container {
  position: relative;
  display: inline-block;
  padding-bottom: 8px;
}

.roles-dropdown-toggle {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  background-color: #f8f9fa;
  border: 1px solid #EC7600;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 12px;
  color: #EC7600;
}

.roles-dropdown-toggle:hover {
  background-color: #e9ecef;
  border-color: #EC7600;
}

.roles-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1002;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 180px;
  padding-top: 8px;
  margin-top: -4px;
}

.roles-dropdown-item {
  padding: 8px 12px;
  border-bottom: 1px solid #f8f9fa;
  cursor: default;
  font-size: 12px;
  color: #495057;
}

.roles-dropdown-item:last-child {
  border-bottom: none;
}

.roles-dropdown-item:hover {
  background-color: #f8f9fa;
}

/* User Profile Dropdown Styles */
.user-profile-dropdown-container {
  position: relative;
  display: inline-block;
  padding: 14px 15px;
  padding-bottom: 8px;
}

.user-profile-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.user-profile-icon-wrapper:hover {
  opacity: 0.8;
}

.user-profile-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1002;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 220px;
  padding-top: 8px;
  margin-top: -4px;
}

.user-profile-dropdown-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f8f9fa;
  cursor: default;
  font-size: 14px;
  color: #495057;
}

.user-profile-dropdown-item:last-child {
  border-bottom: none;
}

.user-profile-dropdown-item:hover {
  background-color: #f8f9fa;
}

.user-profile-email,
.user-profile-country {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.user-profile-country {
  margin-bottom: 0;
  font-size: 12px;
  color: #6c757d;
}

.user-profile-logout {
  cursor: pointer;
  color: #e11900;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.user-profile-logout:hover {
  background-color: #fff5f5;
  color: #c1121f;
}

/* Help Dropdown Styles */
.help-dropdown-container {
  position: relative;
  display: inline-block;
  padding: 14px 15px;
  padding-bottom: 8px;
}

.help-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.help-icon-wrapper:hover {
  opacity: 0.8;
}

.help-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1002;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 280px;
  padding-top: 8px;
  margin-top: -4px;
}

.help-dropdown-item {
  padding: 16px;
  border-bottom: 1px solid #f8f9fa;
  cursor: default;
  font-size: 14px;
  color: #495057;
}

.help-dropdown-item:last-child {
  border-bottom: none;
}

.help-message {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  line-height: 1.5;
  font-size: 14px;
  color: #495057;
}

.help-message i {
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 2px;
}

.help-message span {
  flex: 1;
}

.help-service-owners {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  align-items: center;
}

.help-service-owner-tag {
  display: inline-block;
  padding: 6px 12px;
  background-color: #e7f3ff;
  border: 1px solid #007bff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #007bff;
  cursor: default;
}

.help-service-owner-tag:hover {
  background-color: #d0e7ff;
}

.help-permissions-item {
  cursor: pointer;
}

.help-permissions-item:hover {
  background-color: #f0f8f0;
}

/* Permissions Modal Styles */
.permissions-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}

.permissions-modal-content {
  width: 35%;
  height: 100%;
  background-color: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.permissions-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.permissions-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
}

.permissions-modal-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #6c757d;
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.permissions-modal-close:hover {
  color: #ec4899;
}

.permissions-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

.permissions-policy-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.permissions-policy-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.permissions-policy-label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.permissions-policy-value {
  font-size: 14px;
  color: #495057;
  padding: 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  word-break: break-all;
  line-height: 1.5;
}

.permissions-identity-accordion-item {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.permissions-identity-accordion-header {
  padding: 8px 12px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.permissions-identity-accordion-header:hover {
  background-color: #e9ecef;
}

.permissions-identity-accordion-item.expanded .permissions-identity-accordion-header {
  border-bottom: 1px solid #dee2e6;
  background-color: #e9ecef;
}

.permissions-identity-accordion-header-content {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.permissions-identity-accordion-content {
  padding: 12px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: slideDown 0.3s ease-out;
}

.permissions-identity-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.permissions-identity-label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.permissions-policy-roles {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.permissions-roles-accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.permissions-role-accordion-item {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.permissions-role-accordion-header {
  padding: 8px 12px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.permissions-role-accordion-header:hover {
  background-color: #e9ecef;
}

.permissions-role-accordion-item.expanded .permissions-role-accordion-header {
  border-bottom: 1px solid #dee2e6;
  background-color: #e9ecef;
}

.permissions-role-accordion-header-content {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.permissions-role-name {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.permissions-role-accordion-content {
  padding: 8px 12px;
  background-color: #fff;
  animation: slideDown 0.3s ease-out;
}

.permissions-role-mrn-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.permissions-role-mrn-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.permissions-role-mrn-value {
  font-size: 12px;
  color: #6c757d;
  font-family: monospace;
  word-break: break-all;
  padding: 6px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.permissions-policy-mapping {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.permissions-action-group {
  padding: 10px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.permissions-action-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.permissions-policies-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.permissions-policy-card {
  padding: 8px 10px;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  border-left: 3px solid #ec4899;
}

.permissions-policy-name-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.permissions-policy-name {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  font-family: monospace;
  flex: 1;
  word-break: break-all;
}

.permissions-copy-button {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.permissions-copy-button:hover {
  background-color: #f8f9fa;
  color: #ec4899;
}

.permissions-copy-button i.fa-check {
  color: #ec4899;
}

.permissions-policy-description {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.5;
}

/* Features Accordion Styles */
.features-accordion-container {
  margin-top: 40px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.features-accordion-modal {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.features-accordion-title {
  font-size: 20px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.features-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-accordion-item {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.feature-accordion-header {
  padding: 10px 14px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.feature-accordion-header:hover {
  background-color: #e9ecef;
}

.feature-accordion-item:not(:last-child) {
  margin-bottom: 0;
}

.feature-accordion-item.expanded .feature-accordion-header {
  border-bottom: 1px solid #dee2e6;
  background-color: #e9ecef;
}

.feature-accordion-header-content {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #495057;
}

.feature-accordion-feature-name {
  flex: 1;
  font-weight: 600;
}

.feature-accordion-route {
  font-size: 13px;
  color: #6c757d;
  font-family: monospace;
  background-color: #e9ecef;
  padding: 4px 8px;
  border-radius: 4px;
  margin-left: 12px;
}

.feature-accordion-content {
  padding: 12px 14px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  to {
    opacity: 1;
    max-height: 2000px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

.feature-action-group {
  padding: 10px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.feature-action-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.feature-policies-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-policy-item {
  padding: 8px 10px;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  border-left: 3px solid #ec4899;
}

.feature-policy-name-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.feature-policy-name {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  font-family: monospace;
  flex: 1;
  word-break: break-all;
}

.feature-copy-button {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-copy-button:hover {
  background-color: #f8f9fa;
  color: #ec4899;
}

.feature-copy-button i.fa-check {
  color: #ec4899;
}

.feature-policy-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.feature-policy-severity {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.severity-low {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.severity-medium {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.severity-high {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.feature-policy-description {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.5;
}

.action-button {
  min-width: 130px;
  padding: 12px 15px;
  border-radius: 0;
}

.action-button-1 {
  min-width: 120px;
  padding: 10px 15px;
  border-radius: 0;
}

.action-button-2 {
  min-width: 120px;
  padding: 6px 15px;
  border-radius: 0;
}

.widget-outer-view-image {
  width: 100%;
  cursor: pointer;
}

.widget-selected-language-button {
  width: 150px !important;
}

.widget-language-button {
  max-width: 150px !important;
}

.widget-inner-view-image .flex-container {
  min-height: 200px;
}

.widget-outer-view-image .flex-container {
  text-align: center;
  font-size: 40px;
}

.uploaded-image-cross {
  position: absolute;
  right: 0;
  top: 0;
}

.upload-image-icon {
  position: absolute;
  left: 35%;
  top: 35%;
  opacity: 0.8;
  /* left: 0;
  top: 0; */
}

.widget-uploaded-image {
  width: 100%;
}

.widget-uploaded-icon {
  width: 30%;
}

.widget-uploaded-image-full {
  width: 100%;
  height: 200px;
  object-fit: contain;
}

.popup-footer {
  margin-top: 15px;
}

.popup-footer button {
  padding: 10px 14px;
  margin: 10px 7px 0;
  border-radius: 0;
  min-width: 120px;
}

.widget-details {
  border-top: 1px solid #c9d6de;
  padding: 10px 10px;
  font-size: 12px;
}

.widget-details:empty {
  border-top: none;
  padding: 0;
}

.one-three-widget-view,
.single-widget-view {
  margin: 0 -10px 25px;
}

.widget-group-view {
  position: relative;
  margin-bottom: 25px;
  font-size: 14px;
  float: none;
  display: inline-block;
  vertical-align: top;
}

.widget-group-view-widgets {
  margin-top: 15px;
}

.widget-background-yellow {
  background-color: #ffffe0 !important;
}

.widget-group-widgets-details {
  float: left;
  width: calc(100% - 300px);
  padding: 10px;
}

.banner-widget-group-view {
  position: relative;
  margin-bottom: 30px;
}

.banner-widget-group-view-image {
  width: 100%;
  height: 100px;
  object-fit: contain;
  background-color: #fff;
}

.action-button-full {
  width: 100%;
  padding: 10px 15px;
  border-radius: 0;
}

.widget-view-container {
  display: inline-block;
  float: none;
  vertical-align: top;
}

.widget-details-row {
  display: inline-block;
  vertical-align: middle;
  padding: 0 5px 0 0;
  margin: 0 5px 5px 0;
  border-right: 1px solid #52616a;
}

.widget-details .widget-details-row:last-child {
  border-right: none;
}

.widget-location-view {
  font-size: 14px;
  padding: 10px 10px 15px;
  background-color: #ffffff;
}

.widget-location-view label,
.widget-location-view .form-control {
  font-size: 14px;
}

.inline-details {
  display: inline-block;
  vertical-align: middle;
  padding: 0 5px 0 0;
  margin: 0 5px 5px 0;
  border-right: 1px solid #52616a;
}

.locations-heading {
  padding: 10px;
  font-weight: bold;
  font-size: 16px;
  background-color: #eee;
  border: 1px solid #c9d6de;
}

.no-location-found {
  text-align: center;
  padding: 15px;
  font-weight: bold;
  font-size: 16px;
  border: 1px solid #c9d6de;
}

.add-new-widget-group-location {
  padding: 15px 0;
}

.add-new-widget-group-location button {
  border-radius: 0;
  width: 130px;
}

.taxonomy-dropdown-box label {
  font-size: 14px;
}

.taxonomy-select-box {
  margin: 15px 0 0;
  padding: 0 10px;
}

.taxonomy-select-box-1 {
  width: 15%;
}

.taxonomy-select-box-2 {
  width: 20%;
}

.taxonomy-select-box-3 {
  width: 30%;
}

.taxonomy-select-box-4 {
  width: 35%;
}

.taxonomy-dropdown-box {
  margin: 0 10px;
}

.taxonomy-select-box .Select {
  min-width: 100%;
}

.catalog-product-table .Select {
  margin: 0;
}

.no-data-found {
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  margin-top: 15px;
  padding: 40px 15px;
}

.single-edit-product-row tr td {
  vertical-align: top !important;
}

.product_taxonomy_failed .product-taxonomy-details label,
.product_upload_success .product-details .emptyPic {
  color: #ffffff;
}

.image-error .emptyPic {
  border-color: #a94442;
}

.landing-page-view {
  padding: 10px;
  margin-bottom: 30px;
}

.file-error-line {
  margin: 0;
  font-weight: 500;
  font-size: 14px;
}

.variation_status_0 {
  color: #fff !important;
  background-color: #f0ad4e !important;
  border-color: #eea236 !important;
}

.variation_status_1 {
  color: #fff !important;
  background-color: #d9534f !important;
  border-color: #d43f3a !important;
}

.variation_status_2 {
  color: #fff !important;
  background-color: #5cb85c !important;
  border-color: #4cae4c !important;
}

.nav-tabs a {
  cursor: pointer;
}

.url-link {
  color: #c9302c;
  font-weight: bold;
  font-size: 16px;
}

.bd-am-user-add .Select {
  margin-top: 0;
}

.red-column {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}

.green-column {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}

.visual-search-image {
  width: 200px;
  position: relative;
  margin: 10px auto;
}

.visual-search-image .product-image-2 {
  max-height: 200px !important;
  max-width: 200px !important;
}

.experiment-view {
  margin-bottom: 20px;
  display: inline-block !important;
  float: none;
  vertical-align: top;
}

.experiment-variants-view {
  margin-bottom: 10px;
}

.experiment-variants-view:last-child {
  margin-bottom: 0;
}

.experiment-variant-view {
  margin-bottom: 15px;
  padding: 15px;
}

.experiment-variant-remove {
  position: absolute;
  top: 0;
  right: 0;
}

.break-word {
  word-wrap: break-word;
}

.video-rating-image {
  max-width: 100px;
  max-height: 200px;
  object-fit: contain;
}

.catalog_collection_name {
  display: inline-block;
  padding: 0 5px;
  border-right: 1px solid #0f213c;
}

.hidden_collection {
  font-weight: bold;
  background-color: #f45b69;
  color: #ffffff;
  padding: 2px 5px;
}

.offer-create-container {
  width: 800px;
  margin: auto;
}

.image-link-remove {
  cursor: pointer;
}

.notification-detail {
  padding: 15px 15px;
  margin-bottom: 15px;
  position: relative;
}

.notification-detail-remove {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
}

.padding-t-25 {
  padding-top: 25px;
}

.upload-btn-wrapper {
  position: relative;
  display: block;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  opacity: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

.upload-preview {
  color: #8e8e8e;
  font-size: 12px;
  padding: 5px 0;
  display: block;
}

.upload-preview.u {
  text-decoration: underline;
  cursor: pointer;
}

.btn-sms-portal {
  padding: 40px;
  background: aqua;
  color: rgb(159, 32, 137);
  width: 100%;
  font-size: 18px;
  line-height: 1.333;
  border-radius: 0;
  border: 1px solid rgb(159, 32, 137)54;
}

.btn-sms-primary {
  background: aqua;
  color: rgb(159, 32, 137);
  width: 80%;
  font-size: 18px;
  line-height: 1.333;
  border-radius: 0;
  border: 1px solid rgb(159, 32, 137)54;
}

.sms-text-counter {
  padding: 2px 10px;
  background: #fafafa;
  color: rgb(159, 32, 137);
  border-radius: 20px;
  border: 1px solid #ddd;
}

.sms-text-counter.danger {
  color: rgb(192, 84, 84);
}

.sms-message-display {
  min-height: 100px;
  display: block;
  display: block;
  padding: 10px;
  font-size: 16px;
  line-height: 1.42857143;
  color: #333333;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-family: monospace;
  overflow: auto;
  text-overflow: ellipsis;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  /* -webkit-appearance: none;  */
  margin: 0;
}

.reduce-margin-15 {
  margin-left: -15px;
}

.margin-left-15 {
  margin-left: 15px;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-left-5 {
  margin-left: 5px;
}

.cursor-pointer {
  cursor: pointer;
}

.justify-content-center {
  justify-content: center;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}

/*.nav > li > a:hover, .nav > li > a:focus {
    text-decoration: none;
    background-color: rgb(159, 32, 137) !important;
}*/

.user-profile-view input {
  width: 100%;
  padding: 5px 10px;
}

.user-profile-view label {
  padding: 5px 10px;
  margin-bottom: 0;
}

.react-datepicker-popper {
  z-index: 10;
}

.simple-table th,
td {
  padding: 5px !important;
}

.staticEditorWorkBox {
  height: 400px !important;
  border: 1px solid #f1f1f1;
}

.row-flex {
  display: flex;
  flex-direction: row;
}

.col-flex {
  display: flex;
  flex-direction: column;
}

.space-even-flexBox {
  justify-content: center;
  align-items: center;
}

.sectionBox {
  border: 1px solid silver;
  padding: 10px 0;
  margin: 10px 0;
}

.pageItem {
  padding: 10px;
  width: 100%;
  margin-bottom: 20px;
}

.editorContainer {
  display: flex;
  align-self: center;
}

.tox-notifications-container {
  display: none;
}

.leaderboard-btn {
  min-width: 120px;
  padding: 8px 10px;
  border-radius: 0;
  font-weight: bold;
}

.leaderboard-head-btn {
  margin: 25px 40px;
}

.form__imageab {
  position: relative;
  padding-top: 15px;
}

.form__imageab-label {
  display: inline-block;
  position: absolute;
  color: #c7c7c7;
  font-weight: 400;
  background: white;
  margin: 0;
  font-size: 12px;
  top: 8px;
  left: 20px;
  padding: 0 5px;
}

.form__imageab-input {
  display: block;
  padding: 10px 10px;
  border: 1px solid #c7c7c7;
}

.img_ab-wrapper {
  border: 1px solid #ddd;
  display: table-cell;
  vertical-align: middle;
  align-items: center;
  margin-bottom: 10px;
  background-color: #dddddd94;
  height: 150px;
  max-width: 200px;
}

.img_ab-wrapper img {
  max-height: 100%;
  margin: 0 auto;
}

.img_ab-err {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.break-word {
  word-break: break-word;
}

.rule-engine-create-table {
  width: 60%;
}

.rule-engine-test-table {
  width: 35%;
  margin-left: 3%;
}

.rule-engine-heading {
  background: rgb(159, 32, 137);
  color: #fff;
}

.rule-engine-create-table tr {
  width: 100%;
}

.rule-engine-create-table tr th {
  padding: 5px !important;
}

.rule-engine-create-table tr th:nth-child(1) {
  width: 20%;
}

.rule-engine-create-table tr th:nth-child(2) {
  width: 80%;
}

.rule-engine-create-table tr th:nth-child(2) textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px;
}

.test-row-height {
  height: 500px;
}

.deactivated-button {
  opacity: 0.5;
}

.test-validation-input-box {
  width: 100%;
  min-height: 200px;
  padding: 10px;
}

.supplier-address .Select {
  min-width: 150px;
}

.clp-search-box {
  font-size: 20px;
  padding: 2px;
  margin: 10px;
}

.card-catalog {
  position: relative;
  cursor: pointer;
  min-height: 190px;
  height: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 2px;
  max-width: 270px;
}

.card-na {
}

.card-catalog .card-badge {
  position: absolute;
  border-radius: 50%;
  background: white;
  padding: 5px;
  text-align: center;
  top: -17px;
  width: 34px;
  left: -17px;
  border: 1px solid #bebbbb;
}

.modal-product-card {
  border: 1px solid #ddd;
  margin: 15px 0;
  padding: 0 15px;
  cursor: pointer;
}

.horizontall-scroller {
  margin: 15px 0;
  padding: 0;
  white-space: nowrap;
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid #f8f8f8;
}

.scroller-element {
  display: inline;
  border: 1px solid #ddd;
  margin: 0 10px;
}

.error-modal-body {
  padding: 0px 15px 15px;
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}

.error-message {
  color: red;
  text-align: center;
}

.btn-light {
  color: red;
  margin-top: 5px;
}

.cat-nav {
  display: flex;
  margin-top: 30px;
  padding: 10px;
}

.cat-title {
  margin-left: 10px;
  padding: 5px;
  cursor: pointer;
  font-size: 16px;
}

.dotted-box {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  border: solid 1px #eb4f85;
  background-color: #fff;
}

.intent-rule-table {
  display: flex;
  flex-direction: column;
  border: 1px solid #c9d6de;
}

.intent-rule-td {
  display: flex;
  flex-direction: column;
}

.intent-add-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-field-wrapper {
  display: flex;
  flex-direction: column;
}

.search-field {
  display: flex;
  align-items: center;
}

.search-input {
  padding: 10px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.search-icon {
  margin-right: 8px;
}

.add-condition-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.add-condition-btn-text {
  padding-right: 5px;
  color: #52616a;
  font-size: 18px;
  margin-left: 8px;
  font-weight: inherit;
}

.intent-error-msg {
  background-color: #ffd4d4;
  text-align: center;
  padding: 5px;
  margin-bottom: 50px;
}

.intent-error-text {
  color: #fc3a3a;
  font-size: 25px;
  text-align: center;
}

.intent-add-edit-btn {
  margin-top: 50px;
  margin-left: 20px;
}

.rule-condition {
  padding: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.rule-condition-wrapper {
  display: flex;
  margin-right: 10px;
  align-items: center;
  border: 1px solid #ebecf0;
  background-color: #fafbfc;
}

.fa-trash {
  color: red;
  font-size: 25px;
}

.rule-action {
  margin-bottom: 20px;
  margin-top: 10px;
}

.rule-action-container {
  margin-top: 10px;
  margin-bottom: 5px;
  padding: 5px;
  border: 1px solid #ebecf0;
  border-radius: 5px;
  background-color: #fafbfc;
}

.rule-action-name {
  display: flex;
  margin: 5px;
  padding: 3px;
  align-items: center;
}

.fa-plus-circle {
  padding-right: 5px;
  margin-left: 20px;
  color: #52616a;
  font-size: 18px;
}

.fa-close {
  font-size: 25px;
  color: #f54814;
}

.action-cat-container {
  display: flex;
  margin-left: 15px;
  flex-direction: column;
  margin-top: 5px;
  margin-bottom: 10px;
}

.action-sub-container {
  margin-left: 8px;
  display: flex;
  align-items: center;
}

.arrow-pointer {
  color: #52616a;
  margin-right: 5px;
}

.action-option-container {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.action-option-list {
  margin-left: 15px;
  display: flex;
  align-items: center;
}

.opt-del {
  margin-left: 15px;
}

.border-gray {
  border: 1px solid #c9d6de;
}

.uat-images {
  width: 160px;
  height: 160px;
  object-fit: contain;
  margin-bottom: 10px;
}

.uat-content-left {
  width: 530px;
  max-height: calc(100vh - 170px);
  overflow: scroll;
}

.uat-content-right {
  width: calc(100% - 530px);
  max-height: calc(100vh - 170px);
  overflow: scroll;
}

.uat-content-right .radio-inline:first-child {
  margin-left: 5px;
}

.color-black {
  color: black;
}

.color-007 {
  color: #007eff
}

.border-radius-5 {
  border-radius: 5px;
}

.notice-input-card {
  margin: 10px;
  margin-bottom: 30px;
  box-shadow: 0 0 5px #5a5a5a3f;
  padding: 20px;
  border-radius: 10px;
  overflow: hidden;
}

.notice-input-card-input {
  width: 100%;
  height: 35px;
  padding: 5px;
  border-radius: 2px;
  border: 1px solid rgb(177, 177, 177);
}

.notice-input-card-input:focus {
  outline: none;
  border: 1.5px solid rgb(0, 0, 0);
  box-shadow: 0 0 10px #5a5a5a3f;
}

.card-input-container {
  margin-top: 30px;
}

.card-input-container label {
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: 12px;
}

.card-input-container textarea {
  width: 100%;
  min-height: 200px;
  border: 1px solid rgb(177, 177, 177);
  border-radius: 3px;
  padding: 5px;
}

.card-input-container span {
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-left: 10px;
}

.card-notice-button-container {
  margin-top: 25px;
  margin-bottom: 10px;
}

.card-notice-button-container button {
  height: 40px;
  width: 250px;
  border-radius: 5px;
  font-size: 14px;
  letter-spacing: 0.05em;
}

.card-notice-clear-button {
  background: transparent;
  border: 0px;
}

.card-notice-clear-button:hover {
  box-shadow: 0 0 5px #5a5a5a36;
}

.card-notice-submit-button {
  border: 0px;
  background-color: #eb4e85;
  color: #fff;
}

.single-notice-card {
  box-shadow: 0 0 10px #5a5a5a18;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid rgba(155, 155, 155, 0.527);
  margin: 3px 10px 40px 10px;
  overflow: hidden;
}

.notice-container {
  margin-left: 50px;
  max-width: 665px;
}

.horizontal-center {
  /* left: 50%;
  position: absolute;
  transform: translate(-50%, 0px);
  width: 50%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.single-notice-card-heading {
  margin: -20px;
  padding: 20px;
  background-color: #d3d3d394;

  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: 12px;

  margin-bottom: 20px;
  padding-bottom: 10px;
}

.single-notice-card-title {
  font-size: 20px;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  font-weight: 500;
}

.single-notice-edit-button {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  border: 0px;
  background-color: #eb4e85;
  color: #fff;
}

.notice-card-edit-block {
  text-align: center;
  background: #ff00002e;
  margin: -20px;
  margin-top: 30px;
  color: red;
  letter-spacing: 0.05em;
  padding: 10px;
  font-size: 14px;
  text-transform: capitalize;
}

.button-loading {
  opacity: 50%;
}

.spinner-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.row-margin-container {
  display: flex;
  margin: 10px 0px 20px 0px;
}

.form-group-display-flex {
  display: flex;
  justify-content: space-between;
}

.form-group-display-flex .reseller-name {
  margin-right: 20px;
}

.form-group-display-flex .reseller-user-id {
  margin-right: 20%;
}

.overflow-wrap {
  overflow-wrap: anywhere;
}

.width-100pc {
  width: 100% !important;
}

.sidebar > .sidebar-nav > .nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}

.sidebar > .nav > li {
  width: 100%;
}

.bulk-widget-upload {
  /* height: 60px; */
  padding: 10px;
  margin-bottom: 30px;
}

.bulk-upload {
  margin: 10px;
  padding: 10px;
  text-align: center;
  border: 1px solid #ededed;
  border-bottom-width: 3px;
  border-left-width: 2px;
  cursor: pointer;
  opacity: 0.9;
  overflow: hidden;
}

.bulk-upload-diable {
  background-color: #eee;
  opacity: 0.8;
}

.bulk-upload-icon {
  display: block;
  width: 95%;
  height: 40%;
  position: absolute;
  left: 20px;
  bottom: 20px;
  opacity: 0;
  cursor: pointer;
}

.d-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-b-20 {
  margin-bottom: 20px;
}

.w-30 {
  width: 30%;
}

.w-60 {
  width: 60%;
}


/**************
  css to overwrite bootstrap 5 css to look like old adminpanel starts here
***************/
a {
  text-decoration: none !important;
}

.btn-block {
  display: block;
  width: 100%;
}

.navbar-right > div > a {
  color: #fff;
}

.btn {
  font-size: 14px;
}

.btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.btn-group-justified {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
}

.btn-group-justified > .btn-group {
  display: table-cell;
  float: none;
  width: 1%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}

.radio-inline,
.checkbox-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
}

.radio-inline + .radio-inline,
.checkbox-inline + .checkbox-inline {
  margin-top: 0;
  margin-left: 10px;
}

.radio input[type="radio"],
.radio-inline input[type="radio"],
.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  position: absolute;
  margin-top: 4px \\9;
  margin-left: -20px;
}

#catalog-info-edit input[type="checkbox"],
input[type="radio"] {
  margin-bottom: 0;
  margin-top: 2px;
}

input[type="radio"],
input[type="checkbox"] {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  line-height: normal;
}

.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #737373;
}

.has-error .help-block, .has-error .control-label,
.has-error .radio, .has-error .checkbox,
.has-error .radio-inline, .has-error .checkbox-inline,
.has-error.radio label, .has-error.checkbox label,
.has-error.radio-inline label, .has-error.checkbox-inline label {
  color: #a94442;
}

.form-control:read-only {
  background-color: #fff;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
}

.panel-default {
  border-color: #ddd;
}

.panel-body {
  padding: 15px;
}

.col-md-offset-3 {
  margin-left: 25%;
}

.page-header {
  padding-bottom: 9px;
  border-bottom: 1px solid #eeeeee;
}

.nav-tabs.nav-justified {
  width: 100%;
  border-bottom: 0;
}

.nav.nav-tabs.nav-justified > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}

.nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:focus {
  border: 1px solid #ddd;
}

.nav-tabs.nav-justified > li > a {
  margin-bottom: 5px;
  text-align: center;
}

h4, .h4 {
  font-size: 18px;
}

h5, .h5 {
  font-size: 14px;
}

h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 10px;
  margin-bottom: 10px;
  word-break: break-word;
}

.img-responsive, .thumbnail > img, .thumbnail a > img, .carousel-inner > .item > img, .carousel-inner > .item > a > img {
  display: block;
  max-width: 100%;
  height: auto;
}

h3, .h3 {
  word-break: break-word;
}

.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1,
.col-xs-2, .col-sm-2, .col-md-2, .col-lg-2,
.col-xs-3, .col-sm-3, .col-md-3, .col-lg-3,
.col-xs-4, .col-sm-4, .col-md-4, .col-lg-4,
.col-xs-5, .col-sm-5, .col-md-5, .col-lg-5,
.col-xs-6, .col-sm-6, .col-md-6, .col-lg-6,
.col-xs-7, .col-sm-7, .col-md-7, .col-lg-7,
.col-xs-8, .col-sm-8, .col-md-8, .col-lg-8,
.col-xs-9, .col-sm-9, .col-md-9, .col-lg-9,
.col-xs-10, .col-sm-10, .col-md-10, .col-lg-10,
.col-xs-11, .col-sm-11, .col-md-11, .col-lg-11,
.col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-right: 10px;
  padding-left: 10px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 1px;
}

.list-group-flush > .list-group-item {
  border-width: 1px;
}

.flex {
  display: flex;
}

.modal-dialog {
  pointer-events: inherit !important;
}

@media only screen and (min-width: 768px) {
  .nav-tabs.nav-justified > li {
    display: table-cell;
    width: 25%;
  }

  .nav-tabs.nav-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
    width: 100%;
  }

  .nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:focus {
    border-bottom-color: #fff;
  }
}

/**************
  css to overwrite bootstrap 5 css to look like old adminpanel ends here
***************/

.custom-date-picker .react-datepicker__input-container input {
  width: 100%;
}


.loader-center-align {
  position: fixed;
  left: 0px;
  top: 50%;
  width: 100%;
}

.toggle-div {
  width: 50px;
  height: 26px;
  border: 2px solid rgb(5, 70, 5);
  border-radius: 15px;
  display: flex;
  cursor: pointer;
}

.toggle-checked {
  justify-content: flex-end;
}

.toggle-btn {
  width: 22px;
  height: 22px;
  border-radius: 11px;
  background-color: rgb(5, 70, 5);
}

.main-wrapper-watchers {
  border: 1px solid #c9d6de;
  padding: 5px;
  min-height: 34px;
  max-height: 150px;
  overflow-y: scroll;
  position: relative;
}

.input-watchers {
  border: none;
  position: absolute;
  width: -webkit-fill-available;
  color: black;
}

.wachers-error {
  margin: 0;
  font-size: 90%;
  color: red;
}

.tag-item-watchers {
  background-color: #d4d5d6;
  display: inline-block;
  font-size: 14px;
  border-radius: 30px;
  padding: 0 4px 0 6px;
  display: inline-flex;
  align-items: center;
  margin: 0 0.3rem 0.3rem 0;
}

.tag-item-watchers > .button-watchers {
  background-color: white;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  padding: 0;
  line-height: 1;
  display: flex;
  justify-content: center;
}

/* Audience Status Styles */

.audience-status-wrapper {
  display: flex;
  flex-direction: column;
  border: 1px solid #C9D6DE;
  padding: 16px;
  gap: 12px;
}

.audience-status-common {
  font-size: 12px;
  line-height: 18px;
}

.audience-status-date {
  display: flex;
  gap: 12px;
  width: max-content;
  background-color: #F0F0F0;
  padding: 4px 8px;
  border-radius: 5px;
}

.audience-status-state .audience-status-refreshed {
  color: #038D63;
  background-color: #D3F4EA;
  padding: 4px 8px;
  border-radius: 5px;
}

.audience-status-msg {
  display: flex;
  margin-top: 12px;
  gap: 6px;
}

.audience-status-queue-wrapper {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 8px;
}

.audience-status-state .audience-status-queue {
  color: #F4B619;
  background-color: #FFF4D7;
  padding: 4px 8px;
  border-radius: 5px;
}

.audience-status-queue-content {
  padding: 4px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.audience-status-steps {
  display: flex;
  flex-direction: column;
}

.circle-background,
.circle-progress {
  fill: none;
}

.circle-background {
  stroke: #D8E3FD;
}

.circle-progress {
  stroke: #306CF5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.modal-btn-common {
  color: #306CF5;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.action-button-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.display-flex-justify-space-between-align-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.display-flex-direction-column-align-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.react-diff-view-wrapper {
  margin-top: 1rem;
  margin-bottom: 3rem;
  width: 70rem;
  max-height: 40rem;
  overflow-y: scroll;
  border: .2px solid lightgray;
}

.search-widget-group-id-wrapper {
  display: flex;
  align-items: center;
  margin-left: 7rem;
}

.search-text-area {
  width: 230px;
}

.search-btn {
  margin-top: 15px;
  background-color: #0d6efd;
  color: white;
}

.btn-primary {
  background-color: #9F2089;
  border: none;
}

.btn-info {
  background-color: #9F2089;
  border: none;
  color: white;

}

.btn-primary:hover {
  background-color: #9F2089;
}

.margin-left-minus-10-rem {
  margin-left: -10rem;
}

.default-button {
  border: none;
  background: none;
  padding: 10px 15px;
  display: inline-block;
}

.default-button.active {
  color: #dc3545 !important;
}

.card-title {
  margin-bottom: 0;
}

.card {
  box-shadow: none;
  margin-bottom: 15px;
  overflow: unset;
}

.card:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/style.css"],"names":[],"mappings":"AAAA;EACE,2FAA2F;AAC7F;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,yGAAyG;EACzG,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,wEAAwE;EACxE,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;EACxD,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,wDAAwD;EACxD;mCACiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,kDAAkD;EAClD,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mEAAmE;EACnE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;EACV,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,OAAO;EACP,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ;WACS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,MAAM;EACN,UAAU;EACV,SAAS;EACT,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE;;AAEF;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;;;eAGa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,2BAA2B;;EAE3B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;;EAEf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;;eAEe;AACf;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;EAYE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;eAEe;;AAEf;EACE,WAAW;AACb;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".development {\n  background: url(\"https://s3-ap-southeast-1.amazonaws.com/meesho-static/web/dev.png\") repeat;\n}\n\n.order-booked .btn.btn-info {\n  width: 100px;\n}\n\n.min_num_delays {\n  width: 70px;\n  height: 34px;\n  padding: 0 5px;\n}\n\ninput.break {\n  word-wrap: break-word;\n  word-break: break-all;\n  height: 80px;\n}\n\n.padding-bottom-5 {\n  padding-bottom: 5px;\n}\n\n.padding-bottom-zero {\n  padding-bottom: 0;\n}\n\n.padding-left-20 {\n  padding-left: 20px;\n}\n\n.min-width-70 {\n  min-width: 70px;\n}\n\n.catalog-send-notification {\n  margin: 0 -1px;\n}\n\n.width-min-100 {\n  min-width: 100px;\n}\n\n.form-control.width-min-100 {\n  padding: 5px;\n}\n\nbody,\nhtml {\n  margin: 0;\n}\n\n.border-radius-none {\n  border-radius: 0 !important;\n}\n\n.product-image {\n  width: 100px;\n  height: 50px;\n  object-fit: cover;\n  margin: 0 5px;\n}\n\n.product-image-1 {\n  width: 100%;\n  max-height: 150px;\n  max-width: 150px !important;\n  object-fit: cover;\n  border: none !important;\n}\n\n.product-image-2 {\n  width: 100%;\n  max-height: 100px;\n  max-width: 100px !important;\n  object-fit: cover;\n  border: none !important;\n}\n\n.product-row-content .product-image-2 {\n  max-height: 120px;\n  height: 120px;\n  max-width: 120px !important;\n}\n\n.margin-zero {\n  margin: 0 !important;\n}\n\n.margin-top-1em {\n  margin-top: 1em;\n}\n\n.margin-top-2em {\n  margin-top: 2em;\n}\n\n.margin-top-0 {\n  margin-top: 0px;\n}\n\n.margin-top-10 {\n  margin-top: 10px;\n}\n\n.margin-top-12 {\n  margin-top: 12px;\n}\n\n.margin-top-15 {\n  margin-top: 15px;\n}\n\n.margin-top-20 {\n  margin-top: 20px !important;\n}\n\n.padding-top-10 {\n  padding-top: 10px;\n}\n\n.margin-bottom-zero {\n  margin-bottom: 0;\n}\n\n.margin-tb-10 {\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.margin-tb-0 {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.margin-lr-10 {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.clear {\n  clear: both;\n}\n\n.float-left {\n  float: left;\n}\n\n.float-right {\n  float: right;\n}\n\n.inline-block {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.table {\n  border-collapse: collapse;\n  width: 100%;\n  background-color: #ffffff;\n}\n\n.table-auto {\n  border-collapse: collapse;\n}\n\n.table > tbody > tr > td {\n  border-top: 1px solid #c9d6de;\n}\n\n.table th,\n.table td {\n  border: 1px solid #c9d6de;\n  text-align: center;\n  word-break: break-all;\n  font-size: 14px;\n  vertical-align: middle !important;\n}\n\n.thead-wrapper {\n  border-top: 1px solid lightgrey;\n}\n\n.table.text-top th,\n.table.text-top td {\n  vertical-align: top !important;\n}\n\n.table-auto th,\n.table-auto td {\n  padding: 10px;\n  border: 1px solid #c9d6de;\n  text-align: center;\n  word-break: break-all;\n  font-size: 14px;\n  vertical-align: middle !important;\n}\n\n#supplierlist table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.supplier-table td,\n#page-wrapper th {\n  border: 1px solid #c9d6de;\n  text-align: center;\n  padding: 15px 5px;\n  word-break: break-all;\n  font-size: 12px;\n}\n\n.width-50 {\n  width: 50px;\n}\n\n.width-50-imp {\n  width: 50px !important;\n}\n\n.width-80 {\n  width: 80px;\n}\n\n.width-100 {\n  width: 100px;\n}\n\n.width-110 {\n  width: 110px;\n}\n\n.width-120 {\n  width: 120px;\n}\n\n.width-130 {\n  width: 130px;\n}\n\n.width-150 {\n  width: 150px;\n}\n\n.width-300 {\n  width: 300px;\n}\n\n.width-200 {\n  width: 200px;\n}\n\n.width-185 {\n  width: 185px;\n}\n\n.width-250 {\n  width: 250px;\n}\n\n.width-70 {\n  width: 70px;\n}\n\n.font-weight-500 {\n  font-weight: 500;\n}\n\n.variable-label {\n  font-weight: normal;\n  width: 55%;\n}\n\n.variable-label-input {\n  display: flex;\n  margin-bottom: 5px;\n}\n\n.action-cta {\n  min-width: 90px;\n  padding: 10px 10px;\n  margin: 0 5px;\n  border-radius: 4px;\n}\n\n.action-cta.not-allowed {\n  cursor: not-allowed;\n}\n\n.action-cta-1 {\n  padding: 10px 30px;\n  border-radius: 4px;\n}\n\n.action-cta-2 {\n  padding: 10px 0;\n  border-radius: 4px;\n}\n\n.action-cta-3 {\n  padding: 8px 10px;\n  margin: 0 7px;\n  border-radius: 0;\n  min-width: 100px;\n}\n\n.margin-top-10 {\n  margin-top: 10px;\n}\n\n.page-sub-header {\n  font-size: 20px;\n  font-weight: 700;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.supplier-page .page-sub-header {\n  border-bottom: none;\n}\n\n.delete-block {\n  border: 1px solid #c9d6de;\n  padding: 30px 15px;\n  border-radius: 4px;\n}\n\n.shadow {\n  -webkit-box-shadow: 1px 2px 5px 6px #c9d6de;\n  -moz-box-shadow: 1px 2px 5px 6px #c9d6de;\n  box-shadow: 1px 2px 5px 6px #c9d6de;\n}\n\n.shadow-lite {\n  -webkit-box-shadow: 1px 2px 3px 3px #a7a7a74b;\n  -moz-box-shadow: 1px 2px 3px 3px #a7a7a74b;\n  box-shadow: 1px 2px 3px 3px #a7a7a74b;\n}\n\n.fileInput {\n  padding: 10px;\n  margin: 15px 0;\n  cursor: pointer;\n  border: 1px solid #c9d6de;\n  width: 300px;\n}\n\n.imgPreview {\n  text-align: center;\n  margin: 15px 0;\n  width: 300px;\n  max-height: 200px;\n  border: 1px solid #c9d6de;\n}\n\n.imgPreview img {\n  width: 100%;\n}\n\n.previewText {\n  padding: 40px 15px;\n  font-size: 16px;\n  font-weight: 700;\n  width: 300px;\n}\n\n.add-new-catalog .fileInput,\n.add-new-catalog .previewText,\n.add-new-catalog .imgPreview {\n  width: 100%;\n}\n\n.add-new-catalog .imgPreview {\n  width: 100%;\n  max-height: 100%;\n}\n\n.catalog-view-info {\n  padding: 5px 5px 0;\n}\n\n.catalog-view,\n.collection-view {\n  margin-bottom: 30px;\n}\n\n.catalog-container,\n.collection-container {\n  float: none;\n  width: 25%;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.collection-container.col-md-3 {\n  padding: 0 5px;\n}\n\n.catalog-view-catalog-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.border {\n  border: 1px solid #c9d6de;\n}\n\n.border-top {\n  border-top: 1px solid #c9d6de;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #c9d6de;\n}\n\n.border-left {\n  border-left: 1px solid #c9d6de;\n}\n\n.border-right {\n  border-right: 1px solid #c9d6de;\n}\n\n.catalog-view-image img {\n  width: 100%;\n  height: 250px;\n  object-fit: cover;\n}\n\n.font-20 {\n  font-size: 20px;\n}\n\n.font-18 {\n  font-size: 18px;\n}\n\n.font-16 {\n  font-size: 16px;\n}\n\n.font-15 {\n  font-size: 15px;\n}\n\n.font-14 {\n  font-size: 14px;\n}\n\n.font-12 {\n  font-size: 12px;\n}\n\n.font-11 {\n  font-size: 11px;\n}\n\n.font-10 {\n  font-size: 10px;\n}\n\n.font-13 {\n  font-size: 13px;\n}\n\n.padding-bottom-10 {\n  padding-bottom: 10px;\n}\n\n.padding-bottom-20 {\n  padding-bottom: 20px;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.normal {\n  font-weight: 400;\n}\n\n.catalog-view-action-cta .link-2 {\n  width: 50%;\n  border-radius: 0;\n  padding: 10px 5px;\n}\n\n.catalog-view-action-cta .link-1 {\n  width: 100%;\n  border-radius: 0;\n  padding: 10px 5px;\n}\n\n.radio-inline {\n  margin-left: 20px;\n}\n\n.radio-inline-custom {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-top: 4px;\n}\n\n.radio-inline-custom .label {\n  margin-right: 8px;\n}\n\n.radio-inline.m-0 {\n  margin: 0;\n}\n\nlabel {\n  font-size: 16px;\n}\n\nlabel.min-width-110 {\n  min-width: 110px;\n}\n\n.form-control {\n  border-radius: 0;\n  -webkit-appearance: none;\n  -webkit-border-radius: 0;\n  border: 1px solid #c9d6de;\n  box-shadow: none !important;\n}\n\n.form-control:focus {\n  border-color: #0f213c;\n}\n\n.drop-images-zone {\n  display: block;\n  padding: 50px;\n  cursor: pointer;\n}\n\n.drop-images-uploaded {\n  max-width: 100px;\n  max-height: 100px;\n  margin: 0 10px;\n}\n\n.single-product-upload-row {\n  width: 100%;\n  border-bottom: 0 !important;\n}\n\n.product-row-heading .float-left {\n  padding: 10px 5px;\n  text-align: center;\n  font-weight: 700;\n  border-left: 1px solid #c9d6de;\n  font-size: 12px;\n}\n\n.product-upload-cross {\n  margin-top: 10px;\n}\n\n.product-row-content .float-left {\n  padding: 5px;\n}\n\n.product-row-content .form-control {\n  padding: 6px 5px;\n}\n\n.product-uploaded-image {\n  width: 100%;\n  height: 80px;\n  object-fit: cover;\n  border: 1px solid #c9d6de;\n}\n\n.product-image-upload {\n  width: 100px;\n}\n\n.product-autofill-checkbox {\n  margin-left: 20px;\n  margin-top: 0;\n}\n\n.product-upload-data td {\n  vertical-align: top !important;\n}\n\n.image-full {\n  width: 100%;\n}\n\n.panel {\n  border-radius: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.catalog-image-edit {\n  width: 100%;\n}\n\n.product-uploaded-image-cross {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.product-upload-images .fileInput {\n  max-width: 100%;\n}\n\n.display-flex {\n  display: flex;\n}\n\n.catalog-edit-action a {\n  min-width: 150px;\n  padding: 10px 5px;\n}\n\n.catalog-edit-action button {\n  min-width: 150px;\n  padding: 10px 5px;\n}\n\n.catalog-edit-action .col-md-2 {\n  width: 20%;\n}\n\n.padding-2em {\n  padding: 2em 0;\n}\n\n.edit-catalog-product-add .product-name,\n.edit-catalog-product-add .product-description {\n  width: 18%;\n}\n\n.edit-catalog-product-add .product-upload-images {\n  width: 10%;\n}\n\n.edit-catalog-product-add .product-full-catalog {\n  width: 8%;\n}\n\n.product-row-heading,\n.product-row-content {\n  margin: 0;\n}\n\n.uploaded-image-done {\n  position: relative;\n  height: 120px;\n  min-width: 100px !important;\n}\n\n.deleted-product,\n.deleted-catalog,\n.deleted-collection,\n.deleted-widget-group {\n  background-color: #cdcdcd;\n}\n\n.catalog-view-action-cta {\n  margin: 0 -1px;\n}\n\n#supplierlist .table th,\n#supplierlist .table th {\n  font-size: 12px;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.padding-vertical-15 {\n  padding: 0 15px;\n}\n\n.size-tag {\n  position: relative;\n  margin: 0 3px;\n  color: #fff;\n  background: #93a4af;\n  font-weight: 700;\n  display: inline-block;\n  vertical-align: top;\n  padding: 5px 30px 5px 15px;\n  border-radius: 2px;\n}\n\n.size-remove {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding-top: 4px;\n  padding-left: 7px;\n  padding-right: 7px;\n  cursor: pointer;\n  height: 100%;\n  border-left: 1px solid #fff;\n}\n\n.text-center-important {\n  text-align: center !important;\n}\n\n.added-sizes,\n.add-size-button {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.size-tag-margin {\n  margin: 5px 2px;\n}\n\n.modal-outer {\n  display: none;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1050;\n  background-color: rgba(0, 0, 0, 0.3);\n  overflow: auto;\n}\n\n.overflow-unset {\n  overflow: unset !important;\n}\n\n.modal-content {\n  box-shadow: none;\n  border: 1px solid #c9d6de;\n  color: #52616a;\n  padding: 20px;\n  background-color: #ffffff;\n}\n\n.modal-inner {\n  margin-top: 50px;\n  max-width: 600px;\n  z-index: 1060;\n  background-color: #fff;\n}\n\n.modal-hidden {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n.order-booked-popup .modal-inner,\n.supplier-edit-popup .modal-inner {\n  margin-top: 50px;\n  max-width: 800px;\n  width: 800px;\n}\n\n.supplier-edit-popup .modal-body {\n  padding: 20px 20px;\n}\n\n.supplier-edit-popup .delete-confirm-button {\n  margin-bottom: 10px;\n}\n\n.admin-delete-popup .modal-body {\n  padding: 40px 20px;\n}\n\n.sub-order-reship-popup .modal-inner {\n  margin-top: 50px;\n  max-width: 85%;\n  width: 85%;\n}\n\n.order-timeline-popup .modal-inner,\n.payment-screen-shot .modal-inner {\n  margin-top: 50px;\n  max-width: 600px;\n  width: 600px;\n}\n\n.order-exchange-popup .modal-inner {\n  max-width: 880px;\n  width: 880px;\n  margin-top: 50px;\n}\n\n.order-return-popup .modal-inner {\n  max-width: 580px;\n  width: 580px;\n  margin-top: 50px;\n}\n\n.add-size-body input {\n  display: inline-block;\n  vertical-align: top;\n  margin: 3px 5px 10px 10px;\n}\n\n.modal-outer.opened {\n  display: block;\n}\n\n.order-exchange-popup {\n  overflow: hidden !important;\n}\n\n.col-md-20 {\n  float: left;\n  width: 20%;\n  padding: 0 15px;\n}\n\n.catalog-view-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.table-wrapper {\n  overflow-x: scroll;\n  overflow-y: visible;\n  width: 100%;\n}\n\n.inline-block-table {\n  display: inline-block;\n  border: 1px solid #c9d6de;\n  vertical-align: middle;\n  text-align: center;\n  padding: 10px;\n}\n\n.scrollble-view {\n  width: 100%;\n  overflow: scroll;\n  white-space: nowrap;\n}\n\n.display-flex {\n  display: flex;\n}\n\n.scroll-table {\n  width: 100%;\n  overflow: auto;\n  border-left: 1px solid #c9d6de;\n  border-right: 1px solid #c9d6de;\n}\n\n.scroll-x {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.scroll-table .table {\n  margin-bottom: 0;\n}\n\n.scroll-table .table th:first-child,\n.scroll-table .table td:first-child {\n  border-left: 0 !important;\n}\n\n.scroll-table .table th:last-child,\n.scroll-table .table td:last-child {\n  border-right: 0 !important;\n}\n\n.scroll-table th,\n.scroll-table td {\n  min-width: 50px;\n  min-height: 70px;\n}\n\n.scroll-table th.width-90,\n.scroll-table td.width-90 {\n  min-width: 90px;\n}\n\n.scroll-table th.width-70,\n.scroll-table td.width-70 {\n  min-width: 70px;\n}\n\n.scroll-table th.width-100,\n.scroll-table td.width-100 {\n  min-width: 100px;\n}\n\n.scroll-table th.width-110,\n.scroll-table td.width-110 {\n  min-width: 110px;\n}\n\n.scroll-table th.width-150,\n.scroll-table td.width-150 {\n  min-width: 150px;\n}\n\n.scroll-table th.width-120,\n.scroll-table td.width-120 {\n  min-width: 120px;\n}\n\n.scroll-table th.width-130,\n.scroll-table td.width-130 {\n  min-width: 130px;\n}\n\n.scroll-table th.width-170,\n.scroll-table td.width-170 {\n  min-width: 170px;\n}\n\n.scroll-table th.width-300,\n.scroll-table td.width-300 {\n  min-width: 300px;\n}\n\n.scroll-table th.width-200,\n.scroll-table td.width-200 {\n  min-width: 200px;\n  max-width: 200px;\n}\n\n.scroll-table th.width-250,\n.scroll-table td.width-250 {\n  min-width: 250px;\n}\n\n.scroll-table th.width-350,\n.scroll-table td.width-350 {\n  min-width: 350px;\n}\n\n.scroll-table th.width-400,\n.scroll-table td.width-400 {\n  min-width: 400px;\n}\n\n.scroll-table th.width-500,\n.scroll-table td.width-500 {\n  min-width: 500px;\n}\n\n.scroll-table th.width-800,\n.scroll-table td.width-800 {\n  min-width: 800px;\n}\n\n.scroll-table th.width-1000,\n.scroll-table td.width-1000 {\n  min-width: 1000px;\n}\n\n.order-comments {\n  max-width: 250px;\n}\n\n.order-customer-address {\n  max-width: 130px;\n}\n\n.order-supplier-name {\n  max-width: 150px;\n}\n\n.order-id .pop-btn-link,\n.order-status .pop-btn-link,\n.order-reseller-name .pop-btn-link,\n.order-customer-address .pop-btn-link,\n.order-comments .pop-btn-link,\n.order-supplier-name .pop-btn-link {\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: none;\n  padding: 0;\n}\n\n.order-product-name {\n  width: 190px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: none;\n  padding: 0;\n}\n\n.scroll-table th,\n.scroll-table td {\n  padding: 5px !important;\n}\n\n.scroll-table.big-table th,\n.scroll-table.big-table td {\n  padding: 15px !important;\n}\n\n.filter-item {\n  margin-right: 5px;\n}\n\n.margin-bottom-5 {\n  margin-bottom: 5px;\n}\n\n.margin-bottom-10 {\n  margin-bottom: 10px;\n}\n\n.margin-bottom-15 {\n  margin-bottom: 15px;\n}\n\n.margin-bottom-30 {\n  margin-bottom: 30px;\n}\n\n.form-control.order-status {\n  height: 36px;\n}\n\n.date-picker input {\n  height: 36px;\n  width: 150px;\n  padding: 0 20px 0 5px;\n  text-align: center;\n}\n\n.margin-right-5 {\n  margin-right: 5px;\n}\n\n.margin-right-10 {\n  margin-right: 10px;\n}\n\n.padding-lr-5 {\n  padding: 0 5px;\n}\n\n.padding-lr-10 {\n  padding: 0 10px;\n  margin-bottom: 10px;\n}\n\n.padding-lr-15 {\n  padding: 0 15px;\n}\n\n.padding-lr-10px {\n  padding: 0 10px;\n}\n\n.padding-lr-5px {\n  padding: 0 5px;\n}\n\n#order-status-edit-popup.open {\n  display: block;\n}\n\n#order-status-ordered-popup.open,\n#order-status-shipped-popup.open,\n#order-status-cancelled-popup.open,\n#reseller-info-popup.open {\n  display: block;\n}\n\n.modal-outer.open {\n  display: block;\n}\n\n.popup-date-picker .react-datepicker__input-container {\n  margin-bottom: 0;\n}\n\n.has-error .react-datepicker__input-container {\n  margin-bottom: 0 !important;\n}\n\n.popup-date-picker .react-datepicker__input-container input {\n  height: 34px;\n  padding: 0 15px 0 10px;\n  width: 130px;\n  font-size: 14px;\n}\n\n.react-datepicker {\n  font-size: 100%;\n}\n\n.border-bottom-10 {\n  border-bottom: 1px solid #ddd;\n}\n\n.border-bottom-none {\n  border-bottom: 0 solid #fff;\n}\n\n.order-product-photo img {\n  width: 129px;\n  max-height: 99px;\n  object-fit: cover;\n}\n\n.order-product-photo {\n  padding: 0 !important;\n}\n\n.pop-btn-link {\n  text-decoration: underline;\n  color: #52616a;\n  font-size: 14px;\n  text-transform: capitalize;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.order-status-edit-popup .popup-date-picker .react-datepicker__input-container {\n  margin-bottom: 10px;\n}\n\n.addresse-text {\n  padding-bottom: 5px;\n  font-size: 15px;\n}\n\nbutton.pull-right:focus {\n  outline: none !important;\n}\n\n.react-datepicker__input-container input[disabled] {\n  background-color: #eee;\n  cursor: not-allowed;\n}\n\n.form-control[disabled] {\n  background-color: #eee !important;\n}\n\n.scroll-table table tr {\n  position: static;\n}\n\n.scroll-table table tr .fixed-column {\n  position: absolute;\n  height: 100%;\n  padding-top: 20px !important;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n  position: relative;\n}\n\n.scroll-table table tr .fixed-column.order-date {\n  width: 90px;\n  border-right: none !important;\n}\n\n.scroll-table table tr .fixed-column.order-id {\n  width: 90px;\n  margin-left: 90px;\n  padding-top: 25px !important;\n}\n\n.scroll-table table tbody.source_order_num_class tr .fixed-column.order-id {\n  padding-top: 15px !important;\n}\n\n.scroll-table table tr .fixed-column.order-status {\n  border-left: 0 solid #ddd !important;\n  border-right: none !important;\n  width: 100px;\n  margin-left: 180px;\n  height: 72px;\n  padding-top: 25px !important;\n  border-bottom: none !important;\n}\n\n.scroll-table table tr .fixed-column.order-verified {\n  border-left: 1px solid #ddd !important;\n  border-right: none !important;\n  width: 100px;\n  margin-left: 280px;\n  padding-top: 25px !important;\n}\n\n.scroll-table table tr .fixed-column.order-reseller-name {\n  width: 100px;\n  margin-left: 380px;\n  padding-top: 10px !important;\n}\n\n#table_head.scroll-table table tr .fixed-column.order-reseller-name {\n  padding-top: 25px !important;\n}\n\n.scroll-table .order-total {\n  padding-left: 485px !important;\n  min-width: 570px !important;\n}\n\n.order-status .pop-btn-link {\n  padding: 0;\n}\n\n.order-product-photo.width-130 {\n  height: 70px;\n}\n\n.table > tbody + tbody {\n  border-top: 1px solid #ddd;\n}\n\n.freeze-cover {\n  position: absolute;\n  left: 1px;\n  height: 100%;\n  bottom: 0;\n  width: 480px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.padding-30 {\n  padding: 30px;\n}\n\n.padding-10 {\n  padding: 10px;\n}\n\n.padding-8 {\n  padding: 8px;\n}\n\n.padding-15 {\n  padding: 15px;\n}\n\n.padding-tb-5 {\n  padding: 5px 0;\n}\n\n.padding-tb-10 {\n  padding: 10px 0;\n}\n\n.padding-tb-15 {\n  padding: 15px 0;\n}\n\n.background-dark {\n  background-color: #ddd;\n}\n\n.order-address-form .form-group {\n  margin-bottom: 10px !important;\n}\n\n.order-address-form label {\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\n.order-address-form .form-control {\n  padding: 3px 5px;\n  font-size: 14px;\n  height: 30px;\n}\n\n.shipped-color .color-background {\n  background-color: #b7e1cd;\n}\n\n.cancelled-color .color-background {\n  background-color: #f4c7c3;\n}\n\n.shipped-delayed-color .color-background {\n  background-color: #e10d79;\n}\n\n.shipped-today-color .color-background {\n  background-color: #c9302c;\n}\n\n.payment-pending-color .color-background {\n  background-color: #8e7cc3;\n}\n\n.delivered-color .color-background {\n  background-color: #e6e6e6;\n}\n\n.hold-order-color .color-background {\n  background-color: #f9cb9c;\n}\n\n.return-exchange-color .color-background {\n  background-color: #ffd966;\n}\n\n.post-status-moderated .color-background {\n  background-color: lightgreen;\n  color: black;\n}\n\n.post-status-non-moderated .color-background {\n  background: none;\n  color: black;\n}\n\n.post-status-under-review .color-background {\n  background-color: lightyellow;\n  color: black;\n}\n\n.post-status-blocked .color-background {\n  background-color: #ff6c5c;\n  color: black;\n}\n\n.order-view-reseller-name {\n  padding: 8px 15px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.search-supplier .Select {\n  min-width: 230px;\n}\n\n.search-supplier .Select-value,\n.search-supplier .Select-menu-outer,\n.search-supplier .Select-placeholder,\n.search-supplier .Select-input {\n  text-align: left;\n}\n\n.search-supplier .Select-placeholder {\n  color: #cdcdcd;\n}\n\n.search-supplier .Select-input {\n  display: block !important;\n}\n\n.colored-row .color-background .pop-btn-link {\n  color: #fff;\n}\n\n.colored-row .color-background.row-text-color {\n  color: #fff;\n}\n\n.white-background {\n  background-color: #fff;\n}\n\n.tableFix {\n  position: fixed;\n  right: 15px;\n  left: 216px;\n  z-index: 10;\n  top: 52px;\n  margin-top: 0 !important;\n}\n\n#table_head th {\n  background-color: #fff;\n}\n\n.table_body_margin {\n  margin-top: -1px;\n}\n\n.table_body_margin_scroll {\n  margin-top: 94px;\n}\n\n.z-index-max {\n  z-index: 10000;\n}\n\n.height-80 {\n  height: 80px !important;\n}\n\n.order-status.height-80 {\n  height: 79px !important;\n}\n\n.invisible-layer {\n  position: fixed;\n  height: 73px;\n  top: 52px;\n  background-color: #fff;\n  right: 15px;\n  left: 215px;\n  z-index: 1000;\n}\n\n#wrapper.sidebarClosed .tableFix {\n  left: 16px;\n}\n\n#wrapper.sidebarClosed .invisible-layer {\n  left: 15px;\n}\n\n#table_head::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n#table_head::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 0 #fff;\n}\n\n#table_head::-webkit-scrollbar-thumb {\n  background-color: #fff;\n  outline: 0 solid #fff;\n}\n\n#table_body.scroll-table table tr .fixed-column.order-id {\n  padding-top: 10px !important;\n}\n\n#table_body.scroll-table\ntable\ntbody.source_order_num_class\n.order-product-photo\nimg {\n  min-height: 80px;\n}\n\n#table_body.scroll-table\ntable\ntbody.source_order_num_class\n.fixed-column.order-status {\n  height: 90px;\n}\n\n.whatsapp-chat-button {\n  display: block;\n  padding: 10px;\n  height: 40px;\n  text-align: center;\n  background-color: #25d366;\n  border: 2px solid #25d366;\n  color: #fff !important;\n  background-position: center;\n  background-size: 20px 20px;\n  background-image: url(https://s3-ap-southeast-1.amazonaws.com/meesho-static-test/css/img/ic_whatsapp.png);\n  background-repeat: no-repeat;\n}\n\n.filter-item .Select {\n  min-width: 50px;\n  width: auto;\n  display: inline-block;\n  margin: 0;\n  vertical-align: middle;\n}\n\n.filter-item .Select-placeholder {\n  color: #cdcdcd;\n}\n\n.order-filter .date-picker input {\n  width: 110px;\n  height: 32px;\n}\n\n.table-content {\n  margin-top: 20px;\n}\n\n.filter-block {\n  padding: 3px;\n  margin-bottom: 3px;\n}\n\n.order_number_filter {\n  width: 100px;\n  padding: 0 20px 0 3px;\n  height: 32px;\n  outline: none !important;\n}\n\n.reseller_code_filter {\n  width: 200px;\n  padding: 0 20px 0 3px;\n  height: 32px;\n  outline: none !important;\n}\n\n.customer-number-filter {\n  width: 100px;\n}\n\n.filter-item .Select-placeholder,\n.filter-item .Select--single > .Select-control .Select-value {\n  position: relative;\n  padding-right: 30px;\n}\n\n.filter-item .Select-clear-zone {\n  position: absolute;\n  top: 7px;\n  right: 15px;\n}\n\n.filter-item .Select-arrow-zone {\n  position: absolute;\n  top: 15px;\n  right: -5px;\n}\n\n.filter-item .Select-input {\n  position: absolute;\n  top: 0;\n}\n\n.filter-item .Select-control {\n  width: auto;\n  min-width: 100px;\n}\n\n.filter-submit {\n  padding-left: 25px;\n  padding-right: 25px;\n  outline: none !important;\n  border-radius: 0;\n}\n\n.order-date-filter.has-error {\n  color: #a94442;\n  border-color: #a94442;\n}\n\n.add-clear-x {\n  cursor: pointer;\n  position: absolute;\n  pointer-events: auto;\n  right: 0;\n  top: 0;\n  z-index: 100;\n  font-size: 18px;\n}\n\n.supplier-filter .Select {\n  min-width: 120px !important;\n}\n\n.supplier-filter .Select-control {\n  min-width: 120px !important;\n}\n\n.supplier-filter .Select-input {\n  min-width: 120px;\n}\n\n.supplier-filter .Select-menu-outer {\n  min-width: 120px !important;\n}\n\n.Select-menu-outer {\n  z-index: 1000000;\n}\n\n.filter-hide-button {\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 4px 15px;\n  display: inline-block;\n  vertical-align: middle;\n  outline: none !important;\n}\n\n.booking-details-product-image img {\n  max-width: 100%;\n  max-height: 100px;\n  object-fit: cover;\n}\n\n.popup-sub-heading {\n  padding-bottom: 5px;\n}\n\nul.pagination {\n  margin: 8px 0;\n}\n\n.shipping_time_inputs .shipping_time_start {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 10px 5px;\n}\n\n.shipping_time_start input {\n  width: 40px;\n  padding: 0 3px;\n  height: 30px;\n  text-align: center;\n}\n\n.shipping_time_date input {\n  width: 105px;\n  padding: 0 5px;\n  height: 30px;\n}\n\n.supplier-add-shipping-time.width-150 {\n  padding: 0 !important;\n}\n\n.product_upload_failed .product-details {\n  background-color: #d07079;\n}\n\n.product_taxonomy_failed .product-taxonomy-details {\n  background-color: #d07079;\n}\n\n.product_taxonomy_success .product-taxonomy-details {\n  background-color: #a1de9a;\n}\n\n.product_upload_success .product-details {\n  background-color: #a1de9a;\n}\n\n.verified-filter-dropdown {\n  width: 80px;\n}\n\n.exchange_supplier_status-dropdown {\n  width: 120px;\n}\n\n.return-filter-dropdown {\n  width: 120px;\n  padding: 0 5px;\n}\n\n.filter-dropdown {\n  width: auto;\n}\n\n.catalog-supplier {\n  padding: 5px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background-color: #fff;\n  z-index: 100;\n}\n\n.catalog-supplier-name {\n  padding: 5px 10px;\n  margin: 5px 3px;\n  color: #fff;\n  border-radius: 2px;\n  background-color: #93a4af;\n}\n\n.width-50-per {\n  width: 50%;\n}\n\n.catalog-notification-schedule-popup .modal-inner {\n  max-width: 500px;\n}\n\n.catalog-notification-schedule-popup .modal-inner.deactiveted-catalog {\n  max-width: 750px;\n  width: 750px;\n}\n\n.padding-right-0 {\n  padding-right: 0;\n}\n\n.padding-left-0 {\n  padding-left: 0;\n}\n\n.padding-right-10 {\n  padding-right: 10px;\n}\n\n.padding-zero {\n  padding: 0;\n}\n\n.vertical-align-top {\n  vertical-align: top;\n}\n\n.catalog-container.col-md-3 {\n  padding: 0 5px;\n}\n\n.color-back-text {\n  background-color: #fff;\n  padding: 0 10px 5px;\n  color: #c66;\n  margin: 0 -5px;\n}\n\n.has-selected {\n  border: 1px solid #00f;\n  color: #00f;\n}\n\n.particle-container {\n  height: calc(100vh - 50px);\n  margin: 0;\n}\n\n.flex-container {\n  display: -webkit-flex;\n  -webkit-align-items: center;\n  display: flex;\n  align-items: center;\n}\n\n.flex-container .item1 {\n  -webkit-flex: 1;\n  flex: 1;\n}\n\n.price-range-filter input {\n  width: 100px;\n  height: 30px;\n  padding: 0 5px;\n}\n\n.catalog-type-filter select {\n  width: 100px;\n  height: 34px;\n  padding: 0 5px;\n  display: inline-block;\n}\n\n.price-range-filter .add-clear-x {\n  top: 0;\n  right: 0;\n}\n\n.filter-block.has-error {\n  border: 1px solid #a94442;\n}\n\n.filter-item .Select--multi .Select-control {\n  min-width: 150px;\n  padding-right: 50px;\n}\n\n.filter-item .Select--multi.Select {\n  min-width: 150px;\n}\n\n.Select--multi .Select-value-label {\n  padding: 5px;\n}\n\n.date-selected {\n  border: 1px solid #00f;\n}\n\n.CatalogNameSearch {\n  width: 200px;\n}\n\n.aa-input {\n  background: #fff !important;\n  height: 34px;\n  border: 1px solid #c9d6de !important;\n}\n\n.aa-input:focus {\n  outline: none !important;\n}\n\n#vertical_scrolling_div .order-timeline-list td {\n  padding: 10px !important;\n  height: auto !important;\n  color: #fff;\n  font-size: 14px;\n}\n\n.timeline-message {\n  background-color: #f26c63 !important;\n}\n\n.timeline-time {\n  background-color: #3c5764 !important;\n  width: 150px;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.order-timeline-list {\n  color: #fff !important;\n}\n\n.payment-screen-shot .modal-inner {\n  transition: all 0.5s ease;\n}\n\n.payment-screen-shot.zoomin .modal-inner {\n  max-width: 800px;\n  width: 800px;\n}\n\n.screenshot-image img {\n  cursor: zoom-in;\n  width: 100%;\n}\n\n.payment-screen-shot.zoomin img {\n  cursor: zoom-out;\n}\n\n.form-group .aa-hint,\n.form-group .aa-input {\n  display: block;\n  width: 100%;\n  height: 34px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #555;\n  background: #fff none;\n  padding: 6px 0;\n  border-image: initial;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border-radius: 0;\n  -webkit-appearance: none;\n  -webkit-border-radius: 0;\n  border: 1px solid #c9d6de;\n  box-shadow: none !important;\n}\n\n.form-group .CatalogNameSearch {\n  width: 100%;\n}\n\n.has-error #catalog-name-search {\n  border: 1px solid #a94442 !important;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.form-group .aa-input:focus {\n  border: 1px solid #0f213c !important;\n}\n\n#scroll-table-content .order-timeline-list td {\n  height: auto;\n  padding: 10px;\n}\n\n#scroll-table-content .order-timeline-list th {\n  height: auto;\n  padding: 10px;\n}\n\n#scroll-table-content .order-timeline-list .table-border-none th {\n  border: none !important;\n  text-align: left;\n  padding: 10px 0;\n}\n\n#scroll-table-content .order-timeline-list .table-border-none td {\n  border: none !important;\n  text-align: left;\n}\n\n.column-width-180 {\n  width: 180px;\n}\n\n.catalog-supplier-products-info {\n  margin-bottom: 40px;\n}\n\n.img-max-200 {\n  width: 200px;\n}\n\n.catalog-supplier-products-info table {\n  margin-bottom: 0;\n}\n\n.catalog-supplier-products-info .w-100 {\n  width: 100px;\n}\n\n.catalog-supplier-products-info .w-150 {\n  width: 150px;\n}\n\n.catalog-supplier-products-info .padding-zero {\n  padding: 0 !important;\n}\n\n.catalog-supplier-products-info .w-200 {\n  width: 200px;\n}\n\n.catalog-supplier-products-info .w-170 {\n  width: 180px;\n}\n\n.button-2,\n.button-2:focus {\n  background-color: #b84b9e;\n  border-color: #b84b9e;\n  outline: none !important;\n}\n\n.button-2:hover,\n.button-2:active {\n  background-color: #933c7e;\n  border-color: #933c7e;\n}\n\n.button-3,\n.button-3:focus {\n  background-color: #93228d;\n  border-color: #93228d;\n  padding: 10px 30px;\n  outline: none !important;\n}\n\n.button-3:hover,\n.button-3:active {\n  background-color: #751b70;\n  border-color: #751b70;\n}\n\n.button-4,\n.button-4:focus {\n  background-color: #c83652;\n  border-color: #c83652;\n  padding: 10px 30px;\n  outline: none !important;\n}\n\n.button-4:hover,\n.button-4:active {\n  background-color: #b43049;\n  border-color: #b43049;\n}\n\n.rd-width-300 {\n  width: 300px;\n}\n\n.rd-width-200 {\n  width: 180px;\n}\n\n.padding-20 {\n  padding: 20px;\n}\n\n.background-grey {\n  background: #e5e5e5;\n}\n\n.catalog-supplier-products-info:last-child {\n  margin-bottom: 0;\n}\n\n.catalog-order-cta .alert {\n  margin: 0;\n  border-radius: 0;\n  padding: 10px;\n}\n\n.order-cancel-details div:last-child {\n  max-height: 60px;\n  overflow: hidden;\n}\n\n.order-text-flag,\n.order-change-supplier {\n  display: none;\n}\n\n.payment-screen-shot .modal-content {\n  max-height: calc(100vh - 80px);\n  overflow-y: auto;\n}\n\n#catalog-info-edit label {\n  display: inline-block;\n}\n\n.control-label {\n  margin-bottom: 5px;\n}\n\n#catalog-info-edit input[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  margin-bottom: 0;\n  margin-top: 2px;\n}\n\n.reseller-input-search {\n  width: auto;\n  min-width: 250px;\n  height: 35px;\n  font-size: 14px;\n  outline: none !important;\n  padding: 0 25px 0 5px;\n  border: 1px solid #c9d6de;\n}\n\n.reseller-input-search:focus {\n  border: 1px solid #888;\n}\n\n.reseller_search_result {\n  position: absolute;\n  background-color: #fff;\n  z-index: 10;\n  width: 250px;\n  right: 0;\n  font-size: 14px;\n}\n\n.catalog_search_result {\n  width: 100%;\n}\n\n.reseller_search_result ul {\n  border: 1px solid #c9d6de;\n  border-top: none;\n  padding: 0;\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.reseller_search_result ul:empty {\n  display: none;\n}\n\n.reseller_search_result ul li {\n  padding: 7px;\n  cursor: pointer;\n}\n\n.reseller_search_result ul li:hover {\n  background-color: #ededed;\n}\n\n.ResellerNameSearch .add-clear-x {\n  right: 0;\n  top: 0;\n}\n\n#unsubscribeView {\n  width: 100%;\n  min-height: 100vh;\n}\n\n#unsubscribeView .panel-heading {\n  padding: 15px 10px;\n  background-color: #fff;\n}\n\n#unsubscribeView .panel-title {\n  font-size: 16px;\n  font-weight: 700;\n  text-align: center;\n  line-height: 24px;\n}\n\n#unsubscribeView .panel-body {\n  padding: 15px 0;\n}\n\n.padding-top-2em {\n  padding-top: 2em;\n}\n\n.padding-top-6 {\n  padding-top: 6px;\n}\n\n.unsubscribe-heading {\n  color: rgb(159, 32, 137);\n  padding: 30px 10px 10px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.unsubscribe-form {\n  max-width: 430px;\n  padding: 60px 10px 10px;\n  margin: 0 auto;\n}\n\n.unsubscribe-button {\n  padding: 10px 40px;\n}\n\n.unsubscribe-error {\n  margin: 15px 0 0;\n}\n\n.card {\n  will-change: transform;\n  position: relative;\n  border-radius: 2px;\n  overflow: hidden;\n  -webkit-transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);\n  box-shadow: 0 27px 55px 0 rgba(0, 0, 0, 0.3),\n  0 17px 17px 0 rgba(0, 0, 0, 0.15);\n}\n\n.unsubscribe-button {\n  margin: 0 10px;\n  padding: 10px 0;\n  width: 120px;\n  color: #fff !important;\n  font-weight: 700;\n}\n\n.unsubscribe-no {\n  background-color: #36486b;\n}\n\n.unsubscribe-yes {\n  background: transparent;\n  color: #444 !important;\n  border: 1px solid #b2c2bf;\n}\n\n.success-message-heading {\n  color: #e06377;\n}\n\n.descriptionControl {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer;\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n.descriptionPopup .modal-inner {\n  max-width: 600px;\n}\n\n.supplier-data-table {\n  max-height: calc(100vh - 100px);\n  min-height: 300px;\n  width: 100%;\n  overflow: auto;\n  border: 1px solid #c9d6de;\n  background-color: #ffffff;\n}\n\n.supplier-data-table table {\n  margin-bottom: 0;\n}\n\n.btn-google-sign-up .fa {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 34px;\n  font-size: 1.6em;\n  text-align: center;\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 5px 15px 5px 10px;\n  width: 60px;\n}\n\n.btn-google-sign-up {\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 8px;\n  color: #fff;\n  width: 100%;\n  text-align: left;\n  background-color: #c23321;\n  border-color: rgba(0, 0, 0, 0.2);\n  padding: 0;\n}\n\n.btn-google-sign-up:hover,\n.btn-google-sign-up:active,\n.btn-google-sign-up:focus {\n  color: #fff;\n  background-color: #a32b1c;\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.btn-google-sign-up span {\n  width: 220px;\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.full-page {\n  margin: 0;\n  height: calc(100vh - 50px);\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  flex-flow: column;\n}\n\n.googleLoginButton {\n  width: 280px;\n}\n\n.display-block {\n  display: block;\n}\n\n.fixed_headers {\n  max-width: 1690px !important;\n  width: 1690px !important;\n  border-collapse: collapse;\n}\n\n.fixed_headers thead {\n  display: block;\n  width: 1690px;\n  overflow: auto;\n}\n\n.fixed_headers tbody {\n  display: block;\n  width: 1690px;\n  height: 300px;\n  overflow: auto;\n}\n\n#supplierlistdeleted .supplier-data-table {\n  max-height: calc(100vh - 150px);\n}\n\n.catalog_trend {\n  font-size: 14px;\n  color: #555;\n}\n\n.catalog_trend .Select-placeholder {\n  color: #888;\n  font-size: 14px;\n}\n\n.clockpicker.form-control {\n  border-left: 0;\n}\n\n.variation-popup .modal-inner {\n  max-width: 1000px !important;\n  width: 1000px !important;\n}\n\n.right {\n  float: right;\n}\n\n.orderCount {\n  color: white;\n  margin-top: 15px;\n  font-weight: bold;\n  position: absolute;\n  top: 0;\n  left: calc(50% - 200px);\n  width: 400px;\n  text-align: center;\n}\n\n.img-height-150 {\n  max-height: 150px;\n  width: 100%;\n  object-fit: cover;\n}\n\n.passbook-photo {\n  max-width: 100%;\n  max-height: 80px;\n  object-fit: contain;\n  cursor: zoom-in;\n}\n\n.fixed-header {\n  table-layout: fixed;\n}\n\n/*.fixed-header tbody {display: block;overflow: auto;width: 100%;height: 300px;}*/\n.payment-button button {\n  padding: 7px 20px;\n  margin: 0 5px;\n}\n\n#bank_details_reseller_search {\n  width: 315px;\n  font-size: 14px;\n}\n\n#bank_details_reseller_search .reseller_search_result ul {\n  padding: 0;\n}\n\n#bank_details_reseller_search .reseller-input-search {\n  width: 200px;\n  height: 35px;\n  padding: 0 25px 0 5px;\n}\n\n#bank_details_reseller_search .reseller_search_result {\n  width: 200px;\n  right: 1px;\n}\n\n#bank_details_reseller_search.ResellerNameSearch .add-clear-x {\n  width: 25px;\n  right: 1px;\n  top: -10px;\n}\n\n.referral-details-page\n#bank_details_reseller_search.ResellerNameSearch\n.add-clear-x {\n  top: -8.5px;\n}\n\n.bank_details_popup_name {\n  max-width: 360px;\n  margin: auto;\n}\n\n.return-image-upload {\n  margin-top: 15px;\n}\n\n.exchange-image-upload {\n  max-width: 640px;\n  margin: 20px auto 20px;\n}\n\n.padding-zero-td {\n  padding: 0 !important;\n}\n\ninput.max-width-50 {\n  max-width: 50px !important;\n  padding: 0 5px;\n}\n\ninput.max-width-70 {\n  max-width: 70px !important;\n  padding: 0 5px;\n}\n\n.uploaded-image-view {\n  width: 140px;\n  height: 120px;\n  margin: auto;\n}\n\n.uploaded-image-view .product-uploaded-image-cross {\n  right: 15px;\n}\n\n.product-uploaded-image {\n  height: 120px;\n}\n\n.emptyPicContainer {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  /* margin: auto; */\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.emptyPic {\n  margin: auto;\n  position: relative;\n  padding-top: 28px;\n  text-align: center;\n  width: 120px;\n  height: 120px;\n  border: 1px solid #ededed;\n  border-bottom-width: 3px;\n  border-left-width: 2px;\n  cursor: pointer;\n  opacity: 0.9;\n  color: #888888;\n  overflow: hidden;\n}\n\n.emptyPic input[type=\"file\"] {\n  display: block;\n}\n\n.fileIcon {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.emptyFileContainer {\n  position: relative;\n  width: 150px;\n  height: 60px;\n  margin: auto;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.emptyFile {\n  padding: 10px 0;\n  text-align: center;\n  width: 150px;\n  border: 1px solid #ededed;\n  border-bottom-width: 3px;\n  border-left-width: 2px;\n  cursor: pointer;\n  opacity: 0.9;\n  color: #888888;\n  overflow: hidden;\n}\n\n.disableCursor {\n  cursor: not-allowed !important;\n}\n\n.uploaded-file-view {\n  min-width: 450px;\n  margin: auto;\n}\n\n.uploaded-file-view > button {\n  text-align: center;\n  margin: 0 20px;\n}\n\n.review-video-update-popup .uploaded-file-view {\n  min-width: auto;\n}\n\n.review-video-update-popup .review-image-box {\n  width: calc(35% - 10px);\n}\n\n.review-video-update-popup .emptyFileContainer {\n  width: auto;\n  height: auto;\n  padding: 10px 0;\n}\n\n.review-video-update-popup .emptyFile {\n  margin: 0 auto;\n}\n\n.review-video-update-popup .youtube-url-input {\n  display: inline-block;\n  width: calc(100% - 70px);\n}\n\n.review-video-update-popup .youtube-url-btn {\n  float: right;\n  width: 70px;\n}\n\n.uploaded-file-view .uploaded-file-cross {\n  right: 15px;\n}\n\n.return-initiate-block {\n  max-width: 480px;\n  margin: auto;\n}\n\n.exchange_dispatch_date .react-datepicker__input-container {\n  margin-bottom: 0 !important;\n}\n\n.filter-container {\n  padding: 10px;\n  background-color: #ffffff;\n}\n\n#scroll-table-content {\n  background-color: #ffffff;\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n\n.order-filter {\n  margin-top: 5px;\n  padding-bottom: 10px;\n}\n\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n  line-height: 30px;\n}\n\n.Select-input {\n  height: 30px;\n}\n\n.Select-control {\n  height: 32px;\n}\n\n.firebase-admin-view .Select-control {\n  height: 38px;\n}\n\n.firebase-admin-view .Select-placeholder,\n.firebase-admin-view .Select--single > .Select-control .Select-value {\n  line-height: 38px;\n}\n\n.filter-item .form-control {\n  height: 32px;\n}\n\n.form-control-feedback {\n  width: 30px;\n  height: 35px;\n  line-height: 35px;\n}\n\n.filter-block input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n\n.filter-select-box {\n  max-width: 120px;\n  padding: 0 5px;\n  font-size: 12px;\n  min-width: 50px;\n}\n\n.aa-input {\n  height: 32px;\n}\n\n.Select--multi .Select-value {\n  margin: 3px 1px 3px;\n}\n\n.modal-footer button,\n.popup-cta button {\n  border-radius: 0;\n  min-width: 110px;\n}\n\n.delete-block {\n  width: 480px;\n  margin: 0 auto;\n}\n\n.remove-act-schedule_date button {\n  width: 110px;\n  border-radius: 0;\n  height: 40px;\n}\n\ninput {\n  outline: none !important;\n}\n\n.remove-act-schedule_date {\n  margin-top: 15px;\n}\n\n.catalog-edit-action a {\n  border-radius: 0 !important;\n}\n\n.corner-ribbon {\n  font-size: 12px;\n  width: 80px;\n  background: #e43;\n  position: absolute;\n  text-align: center;\n  line-height: 20px;\n  letter-spacing: 1px;\n  color: #f0f0f0;\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.corner-ribbon.top-left {\n  top: 10px;\n  left: -12px;\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.corner-ribbon.red {\n  background: #e43;\n}\n\n.ribbon {\n  position: absolute;\n  z-index: 1;\n  overflow: hidden;\n  width: 150px;\n  height: 150px;\n  text-align: right;\n}\n\n.ribbon.left-ribbon {\n  left: 0;\n  top: 0;\n}\n\n.ribbon.right-ribbon {\n  right: -5px;\n  top: -5px;\n}\n\n.ribbon span {\n  font-size: 10px;\n  font-weight: bold;\n  color: #fff;\n  text-transform: uppercase;\n  text-align: center;\n  line-height: 20px;\n  width: 100px;\n  display: block;\n  background: linear-gradient(#ee4433 0%, #e43 100%);\n  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);\n  position: absolute;\n}\n\n.ribbon.left-ribbon span {\n  top: 19px;\n  left: -21px;\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.ribbon.right-ribbon span {\n  top: 19px;\n  right: -21px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.ribbon span::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 100%;\n  z-index: -1;\n}\n\n.ribbon.left-ribbon span::before {\n  border-left: 3px solid #e43;\n  border-right: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n  border-top: 3px solid #e43;\n}\n\n.ribbon.right-ribbon span::before {\n  border-left: 3px solid #e43;\n  border-right: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n  border-top: 3px solid #e43;\n}\n\n.ribbon span::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 100%;\n  z-index: -1;\n}\n\n.ribbon.left-ribbon span::after {\n  border-left: 3px solid transparent;\n  border-right: 3px solid #e43;\n  border-bottom: 3px solid transparent;\n  border-top: 3px solid #e43;\n}\n\n.ribbon.right-ribbon span::after {\n  border-left: 3px solid transparent;\n  border-right: 3px solid #e43;\n  border-bottom: 3px solid transparent;\n  border-top: 3px solid #e43;\n}\n\n.catalog-view-image .ribbon.left-ribbon span,\n.banner-image .ribbon.left-ribbon span {\n  top: 15px;\n  left: -23px;\n  line-height: 25px;\n  font-size: 14px;\n  background: #9F2089;\n}\n\n.catalog-view-image .ribbon.right-ribbon,\n.banner-image .ribbon.left-ribbon {\n  width: 105px;\n  height: 105px;\n}\n\n.catalog-view-image .ribbon.right-ribbon span {\n  top: 23px;\n  right: -30px;\n  line-height: 30px;\n  font-size: 10px;\n  width: 135px;\n}\n\n.catalog-view-image .ribbon.left-ribbon span::before,\n.banner-image .ribbon.left-ribbon span::before {\n  border-left: 3px solid #456990;\n  border-top: 3px solid #456990;\n}\n\n.catalog-view-image .ribbon.left-ribbon span::after,\n.banner-image .ribbon.left-ribbon span::after {\n  border-right: 3px solid #456990;\n  border-top: 3px solid #456990;\n}\n\n.button-deleted-flag {\n  position: relative;\n  z-index: 1;\n}\n\n#table-content {\n  padding: 0 10px;\n}\n\n.supplier-product-table {\n  width: 100%;\n  overflow: auto;\n  border: 1px solid #c9d6de;\n}\n\n.supplier-product-table table {\n  margin-bottom: 0;\n}\n\n.compute-price {\n  padding: 10px 15px;\n  margin-top: 12px;\n}\n\n.btn-medium {\n  width: 150px;\n  padding: 8px 10px;\n  border-radius: 0;\n  font-weight: bold;\n}\n\n.gst_rate_dropdown {\n  width: auto;\n  min-width: 120px;\n  display: inline-block;\n  padding: 0 5px;\n}\n\n.row-eq-height {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.product-image-zoom-box {\n  max-height: 100px !important;\n  overflow: hidden;\n}\n\n.product-row-content .product-image-zoom-box {\n  max-height: 120px !important;\n}\n\n.product-image-zoom,\n.product-image-2 {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.product-image-zoom.zoom-in {\n  z-index: 1000;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  height: 100%;\n  width: 100%;\n}\n\n.product-image-zoom.zoom-in .product-image-2 {\n  max-width: 500px !important;\n  max-height: calc(100vh - 100px);\n  margin-top: 50px;\n  object-fit: contain;\n}\n\n.body-scroll-hidden {\n  overflow: hidden;\n}\n\n.margin-right-30 {\n  margin-right: 30px;\n}\n\n.product-row-content .product-image-zoom.zoom-in .product-image-2 {\n  max-height: calc(100vh - 100px);\n  height: auto !important;\n}\n\n.payment-details-table th {\n  border: none !important;\n  text-align: left !important;\n  padding: 5px 0 !important;\n  font-size: 14px !important;\n}\n\n.payment-details-table td {\n  border: none !important;\n  text-align: left !important;\n  padding: 5px 0 !important;\n}\n\n.payment-table-order-num {\n  background-color: #f9f9f9;\n}\n\n.payment_details_sub_rows .col-lg-4 {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.payment-table-order-num {\n  margin-bottom: 20px;\n}\n\n.payment-table-order-num:last-child {\n  margin-bottom: 0;\n}\n\n.no-payment-found {\n  margin-top: 35px;\n}\n\n.dark-background {\n  background-color: #d4d2d2;\n}\n\n.pop-up-max-height {\n  max-height: calc(100% - 70px);\n  overflow-y: auto;\n}\n\n.paste-zone {\n  min-height: 100px;\n  cursor: cell;\n  background-color: #ffffff;\n}\n\n.selected-tags {\n  color: #fff;\n  border-radius: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  background-color: #305ae3;\n  font-size: 14px;\n  margin: 5px 10px 5px 0;\n  -webkit-transition: all 5s;\n  transition: all 5s;\n  cursor: pointer;\n}\n\n.selected-tag-cross {\n  padding: 0 18px 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 20px;\n  line-height: 34px;\n  font-weight: bold;\n  margin-top: -5px;\n}\n\n.selected-tags-name {\n  padding: 7px 0 7px 18px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.selected-tags:hover {\n  background: #4f73e7;\n}\n\n.search-catalog-selection {\n  padding: 10px 0;\n}\n\n.search-catalog-selection .add-clear-x {\n  top: 0;\n}\n\n.collection_search_result {\n  position: absolute;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  display: none;\n  z-index: 1;\n}\n\n.collection_search_result ul {\n  border: 1px solid #c9d6de;\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.collection_search_result ul:empty {\n  display: none;\n}\n\n.collection_search_result ul li {\n  padding: 7px;\n  cursor: pointer;\n}\n\n.collection_search_result ul li:hover,\n.collection_search_result ul li.selected {\n  background-color: #ededed;\n}\n\n.collection_search_result ul li[disabled] {\n  background-color: #eee !important;\n  cursor: not-allowed;\n}\n\n.collection_search_result.visible {\n  display: block;\n}\n\n.collection-image {\n  width: 100%;\n  max-height: 150px;\n  object-fit: contain;\n}\n\n.collection-view-left .product-image-zoom.zoom-in .collection-image {\n  margin-top: 52px;\n  max-height: calc(100vh - 100px);\n  height: auto !important;\n  max-width: 512px !important;\n  width: auto !important;\n}\n\n#collection-info-view {\n  width: 600px;\n  margin: 30px auto 0;\n}\n\n.border-red {\n  border-color: #a94442;\n}\n\n.compute-price-warning .modal-inner {\n  max-width: 680px;\n  width: 500px;\n}\n\n.compute-price-warning-proceed .modal-inner {\n  max-width: 580px;\n  width: 580px;\n}\n\n.add-new-referral .modal-inner {\n  max-width: 780px;\n  width: 780px;\n}\n\n.referred-details-popup .modal-inner {\n  max-width: 1220px;\n  width: 1220px;\n}\n\n.referred-fraud-popup .modal-inner {\n  max-width: 600px;\n  width: 600px;\n}\n\n.markup_price_error_row td {\n  color: #a94442 !important;\n  border: 2px solid #ebccd1 !important;\n}\n\n.collection_search_filter {\n  right: -1px;\n  left: auto;\n  width: 150px;\n  top: 100%;\n  z-index: 100;\n}\n\n.collection_search_filter ul {\n  border-top: none;\n}\n\n.collection_search_filter li {\n  line-height: 1;\n}\n\n.collection_search_filter ul li {\n  line-height: 1;\n  padding: 10px 8px;\n}\n\n.panel-info-light .panel-heading {\n  background-color: #e0f0f8;\n  color: #5a8ca5;\n}\n\n.supplier-add-edit-container {\n  margin: 0 auto;\n  width: 900px;\n}\n\n.supplier-add-edit-container .control-label {\n  font-size: 14px;\n}\n\n.supplier-add-edit-container .help-block {\n  font-size: 14px;\n}\n\n.private-label-supplier .Select {\n  margin: 0;\n}\n\n.private-label-supplier {\n  width: 200px;\n}\n\n.sorting-container {\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.sorting-container span {\n  color: #212121;\n  font-weight: bold;\n  padding: 7px 0 4px 0;\n  margin: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n  border-bottom: 2px solid transparent;\n}\n\n.sorting-container ul {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.sorting-container ul li {\n  display: inline-block;\n  vertical-align: middle;\n  padding: 7px 0 4px;\n  margin: 0 10px;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.sorting-container ul li.active-sort {\n  color: #2196f3;\n  border-bottom: 2px solid #2196f3;\n  font-weight: bold;\n}\n\n.catalog-s-o-count {\n  position: absolute;\n  background-color: #456990;\n  color: #fff;\n  bottom: 0;\n  padding: 10px 5px;\n  width: 100%;\n  text-align: center;\n}\n\n.catalog-more-button {\n  outline: none !important;\n  width: 100%;\n  background: #9F2089;\n  color: #fff !important;\n  font-weight: bold;\n  padding: 10px 5px;\n  border-radius: 0;\n}\n\n.catalog-more-button:hover {\n  background-color: #9F2089;\n}\n\n.catalog-more {\n  overflow: hidden;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n\n.fixed-action-btn ul {\n  width: 200%;\n  left: -100%;\n  right: 0;\n  text-align: center;\n  position: absolute;\n  bottom: 42px;\n  margin: 0;\n  visibility: visible;\n  background: #ffffff;\n}\n\n.fixed-action-btn ul li {\n  margin-bottom: 15px;\n  width: 50%;\n  float: right;\n}\n\n.fixed-action-btn ul li:last-child {\n  margin-bottom: 0;\n}\n\n.fixed-action-btn ul button,\n.fixed-action-btn ul a {\n  transform: scaleY(0.4) scaleX(0.4) translateY(40px) translateX(0px);\n  opacity: 0;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  cursor: pointer;\n}\n\n.fixed-action-btn.active-button ul button,\n.fixed-action-btn.active-button ul a {\n  outline: none !important;\n  opacity: 1;\n  transform: scaleY(1) scaleX(1) translateY(0px) translateX(0px);\n}\n\n.fixed-action-btn.active-button .catalog-more {\n  overflow: visible;\n}\n\n.fixed-action-btn.active-button ul {\n  visibility: visible;\n}\n\n#payment_timeline-table {\n  margin-bottom: 0;\n}\n\n#payment_timeline-table th {\n  padding: 10px 8px !important;\n}\n\n#payment_timeline-table td {\n  text-align: left !important;\n  padding: 20px 8px;\n}\n\n#payment_timeline-table td.text-center {\n  text-align: center !important;\n}\n\n.auto-height-row th,\n.auto-height-row td {\n  height: auto !important;\n  padding: 10px 5px !important;\n}\n\n.addressEnableHiddenButton {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  border-radius: 0;\n  height: 40px;\n  opacity: 0;\n}\n\n.algolia-autocomplete .aa-dropdown-menu {\n  z-index: 1000 !important;\n}\n\n.has-error span {\n  color: #a94442;\n}\n\n.inline-element {\n  display: inline-block;\n  vertical-align: top;\n  padding-right: 5px;\n  margin-right: 5px;\n  border-right: 1px solid #888;\n}\n\n.btn {\n  outline: none !important;\n}\n\n.bonus-details {\n  max-width: 1020px;\n  width: 1020px;\n}\n\n.bonus-details .panel-body {\n  padding: 10px;\n}\n\n.bonus-details .col-md-4 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.bonus-details .col-md-4 .panel-body {\n  padding: 0;\n}\n\n.bonus-details .row {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.bonus-details th,\n.bonus-details td {\n  padding: 8px 5px !important;\n}\n\n.bonus-details .btn-link {\n  padding: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.bonus-card-head {\n  background-color: #adc9e2;\n}\n\n.bonus-details .panel-heading {\n  letter-spacing: 1.3px;\n  font-size: 14px;\n}\n\n.return-details td,\n.return-details th {\n  padding: 10px 5px !important;\n}\n\n.exchange-details td,\n.exchange-details th {\n  padding: 10px 5px !important;\n}\n\n.image-zoom {\n  cursor: pointer;\n}\n\n.avif-image {\n  cursor: pointer;\n}\n\n.order-exchange-popup .action-cta {\n  padding: 10px 5px;\n}\n\n.right-div {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.r-e-product-image img {\n  max-width: 100%;\n  max-height: 180px;\n}\n\n.r-e-product-info {\n  padding-bottom: 10px;\n}\n\n.reseller-buttons .col-md-2 {\n  width: 16.666% !important;\n}\n\n.reseller-buttons .col-md-2:nth-child(even) {\n  padding: 0;\n}\n\n.reseller-buttons .col-md-2:last-child {\n  padding-right: 15px;\n}\n\n.resellar-referral-details {\n  margin-top: 35px;\n}\n\n.view-buttons {\n  margin: 0 10px;\n  border-radius: 0;\n  min-width: 80px;\n}\n\n.referral-details {\n  margin-bottom: 30px;\n}\n\n.banner-container {\n  margin-bottom: 30px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.single-banner-content.deactivated-banner .banner-container {\n  background-color: #c9d6de;\n}\n\n.banner-image img {\n  width: 100%;\n  object-fit: contain;\n  max-height: 150px;\n}\n\n.app-banners {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.app-banners .col-lg-3 {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.clock-picker .form-group {\n  margin-bottom: 0;\n}\n\n.has-error input,\n.has-error .Select-control {\n  border: 1px solid #a94442;\n}\n\n.single-banner-content {\n  float: none;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.no-banner-found {\n  font-size: 16px;\n  margin: 10px 0 20px;\n  padding: 20px;\n  border: 1px solid #c9d6de;\n  background-color: #ffffff;\n}\n\n.banners-heading {\n  padding: 15px 10px;\n  font-size: 22px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.banners-heading-inner {\n  position: relative;\n  display: inline-block;\n}\n\n.banners-heading-inner:before {\n  content: \"\";\n  top: 14px;\n  position: absolute;\n  right: calc(100% + 10px);\n  border: 2px solid #c9d6de;\n  width: 100px;\n}\n\n.banners-heading-inner:after {\n  content: \"\";\n  top: 14px;\n  position: absolute;\n  left: calc(100% + 10px);\n  border: 2px solid #c9d6de;\n  width: 100px;\n}\n\n.scary-view {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 10000;\n}\n\n.scary-view img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.error-text {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  padding: 7px 10px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.box-shadow {\n  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);\n}\n\n.fraud-table-view {\n  /*max-height: calc(100vh - 150px);*/\n  width: 100%;\n  overflow: auto;\n  border: 1px solid #c9d6de;\n}\n\n.referral-table-view {\n  width: 100%;\n  overflow: auto;\n  border: 1px solid #c9d6de;\n}\n\n.error-message {\n  font-weight: bold;\n  text-align: center;\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  padding: 10px 30px;\n  margin-top: 10px;\n}\n\n.warning-message {\n  font-weight: bold;\n  text-align: center;\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n  padding: 10px 30px;\n  margin-top: 0;\n}\n\n.success-message {\n  font-weight: bold;\n  text-align: center;\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n  padding: 10px 30px;\n  margin-top: 10px;\n}\n\n.plan-details {\n  border: 1px solid #c9d6de;\n  border-top: 0;\n}\n\n.plan-heading {\n  background-color: #c9d6de;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.plan-body {\n  padding: 10px;\n}\n\n.plan-body th {\n  padding: 10px 5px !important;\n}\n\n.plan-details-button button {\n  padding: 10px;\n  border-radius: 0;\n  position: relative;\n  transition: all 0.5s ease;\n}\n\n.plan-details-button .btn-group:nth-child(2) button {\n  border-left: none;\n  border-right: none;\n}\n\n.plan-details-button button.active_view {\n  background-color: #eb4e85;\n  color: #ffffff;\n  font-weight: bold;\n  border-color: #eb4e85;\n}\n\n.plan-details-button button.active_view::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: calc(50% - 10px);\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #eb4e85;\n}\n\n.referral-plan-orders,\n.referral-plan-payments {\n  max-height: 300px;\n  overflow: auto;\n  transition: all 0.5s ease;\n}\n\n.referral-filter {\n  margin-bottom: 20px;\n}\n\n.referral-filter-inline {\n  display: inline-block;\n  vertical-align: middle;\n  padding-right: 15px;\n}\n\n.referral-filter label {\n  padding-right: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n}\n\n.referral-filter select {\n  vertical-align: middle;\n  display: inline-block;\n  border: 1px solid #c9d6de;\n  padding: 5px;\n  width: 80px;\n}\n\n.referral-filter .selected_filter {\n  color: #90111a;\n}\n\n.referral-filter .selected_filter select {\n  border-color: #90111a;\n}\n\n.referral-filter button {\n  border-radius: 0;\n  padding: 5px 15px;\n  min-width: 80px;\n}\n\n.compute-price-warning ul {\n  padding: 0 20px;\n  list-style: disc;\n}\n\n.compute-price-warning ul li {\n  padding-top: 5px;\n}\n\n.cod-upload-file .emptyFileContainer {\n  width: 450px;\n  height: 150px;\n  background-color: #ffffff;\n}\n\n.cod-upload-file .emptyFile {\n  padding: 25px 0;\n  width: 450px;\n  height: 150px;\n}\n\n.cod-upload-file .emptyFile .fa {\n  font-size: 24px;\n}\n\n.cod-upload-file .uploaded-file-view {\n  border: 1px solid #c9d6de;\n  padding: 53px 0;\n  text-align: center;\n  width: 500px;\n  margin: 0 auto;\n}\n\n.upload-file-response {\n  position: relative;\n  padding-bottom: 10px;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.file-view-button {\n  min-width: 100px;\n}\n\n.row-alert {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  font-weight: bold;\n}\n\n.download-response-file {\n  position: absolute;\n  right: 0;\n  bottom: 5px;\n}\n\n.download-response-file button {\n  display: inline-block;\n  background: #3f51b5;\n  border: 1px solid #3f51b5;\n  padding: 8px 12px;\n  border-radius: 2px;\n  color: #fff !important;\n  text-decoration: none !important;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 12px;\n  letter-spacing: 1.5px;\n  transition: all 0.5s ease;\n}\n\n.download-response-file button:hover {\n  background: #283593;\n  border: 1px solid #283593;\n  outline: none;\n}\n\n.order-related-editing div[class^=\"col-md-\"] {\n  background-color: #ffffff;\n}\n\n.edit-heading {\n  font-weight: bold;\n  margin-bottom: 15px;\n  font-size: 20px;\n}\n\n.edit-email-button {\n  margin-top: 27px;\n}\n\n.edit-email-button button {\n  padding: 6px 30px;\n  border-radius: 0;\n}\n\n.Select-input > input {\n  border: none;\n}\n\n.page-links {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 15px 15px 0;\n  padding: 8px 20px;\n  font-weight: bold;\n  border-radius: 0;\n  min-width: 120px;\n}\n\n.tasks-button {\n  font-weight: bold;\n  min-width: 120px;\n  padding: 8px 20px;\n  margin-right: 15px;\n}\n\n.date-input input {\n  width: 100%;\n  height: 34px;\n  border-radius: 0;\n  -webkit-appearance: none;\n  -webkit-border-radius: 0;\n  border: 1px solid #c9d6de;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n}\n\n.page-loader {\n  margin: 0;\n  height: 100vh;\n}\n\n#pinterest-columns {\n  column-width: 320px;\n  column-gap: 15px;\n}\n\n#pinterest-columns .form-group {\n  background: #fefefe;\n  border: 2px solid #fcfcfc;\n  margin: 0 2px 5px;\n  padding: 5px 5px 10px;\n  transition: opacity 0.4s ease-in-out;\n  column-break-inside: avoid;\n}\n\n#pinterest-columns label,\n#pinterest-columns input {\n  margin: 0 !important;\n}\n\n.index-page-links {\n  margin-top: 40px;\n  text-align: center;\n}\n\n.index-page-links ul li {\n  display: inline-block;\n  margin: 0 10px 20px;\n}\n\n.index-page-links ul li a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background: ; */\n  color: rgb(159, 32, 137);\n  text-decoration: none !important;\n  padding: 10px 20px;\n  border: 1px solid rgb(159, 32, 137);\n  border-radius: 4px;\n}\n\n.index-page {\n  padding: 40px;\n}\n\n.table-scrollable {\n  width: 100%;\n  overflow: auto;\n  border: 1px solid #c9d6de;\n  background-color: #ffffff;\n}\n\n.payment_status_yellow_color {\n  background-color: #fecc0c;\n  color: #555555;\n}\n\n.payment_status_red_color {\n  color: #a94442;\n  background-color: #f2dede;\n}\n\n.sync-users-button {\n  margin-bottom: 10px;\n}\n\n.user-name {\n  padding: 14px 15px;\n}\n\n.user-email {\n  margin-bottom: 0;\n  font-size: 14px;\n  color: #495057;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n}\n\n.logout {\n  color: #e11900;\n}\n\n/* Roles Dropdown Styles */\n.roles-dropdown-container {\n  position: relative;\n  display: inline-block;\n  padding-bottom: 8px;\n}\n\n.roles-dropdown-toggle {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 8px;\n  background-color: #f8f9fa;\n  border: 1px solid #EC7600;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  font-size: 12px;\n  color: #EC7600;\n}\n\n.roles-dropdown-toggle:hover {\n  background-color: #e9ecef;\n  border-color: #EC7600;\n}\n\n.roles-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1002;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  min-width: 180px;\n  padding-top: 8px;\n  margin-top: -4px;\n}\n\n.roles-dropdown-item {\n  padding: 8px 12px;\n  border-bottom: 1px solid #f8f9fa;\n  cursor: default;\n  font-size: 12px;\n  color: #495057;\n}\n\n.roles-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.roles-dropdown-item:hover {\n  background-color: #f8f9fa;\n}\n\n/* User Profile Dropdown Styles */\n.user-profile-dropdown-container {\n  position: relative;\n  display: inline-block;\n  padding: 14px 15px;\n  padding-bottom: 8px;\n}\n\n.user-profile-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.user-profile-icon-wrapper:hover {\n  opacity: 0.8;\n}\n\n.user-profile-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1002;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  min-width: 220px;\n  padding-top: 8px;\n  margin-top: -4px;\n}\n\n.user-profile-dropdown-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f8f9fa;\n  cursor: default;\n  font-size: 14px;\n  color: #495057;\n}\n\n.user-profile-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.user-profile-dropdown-item:hover {\n  background-color: #f8f9fa;\n}\n\n.user-profile-email,\n.user-profile-country {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.user-profile-country {\n  margin-bottom: 0;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.user-profile-logout {\n  cursor: pointer;\n  color: #e11900;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.user-profile-logout:hover {\n  background-color: #fff5f5;\n  color: #c1121f;\n}\n\n/* Help Dropdown Styles */\n.help-dropdown-container {\n  position: relative;\n  display: inline-block;\n  padding: 14px 15px;\n  padding-bottom: 8px;\n}\n\n.help-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.help-icon-wrapper:hover {\n  opacity: 0.8;\n}\n\n.help-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1002;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  min-width: 280px;\n  padding-top: 8px;\n  margin-top: -4px;\n}\n\n.help-dropdown-item {\n  padding: 16px;\n  border-bottom: 1px solid #f8f9fa;\n  cursor: default;\n  font-size: 14px;\n  color: #495057;\n}\n\n.help-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.help-message {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n  line-height: 1.5;\n  font-size: 14px;\n  color: #495057;\n}\n\n.help-message i {\n  flex-shrink: 0;\n  margin-right: 8px;\n  margin-top: 2px;\n}\n\n.help-message span {\n  flex: 1;\n}\n\n.help-service-owners {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n  align-items: center;\n}\n\n.help-service-owner-tag {\n  display: inline-block;\n  padding: 6px 12px;\n  background-color: #e7f3ff;\n  border: 1px solid #007bff;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #007bff;\n  cursor: default;\n}\n\n.help-service-owner-tag:hover {\n  background-color: #d0e7ff;\n}\n\n.help-permissions-item {\n  cursor: pointer;\n}\n\n.help-permissions-item:hover {\n  background-color: #f0f8f0;\n}\n\n/* Permissions Modal Styles */\n.permissions-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 2000;\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n}\n\n.permissions-modal-content {\n  width: 35%;\n  height: 100%;\n  background-color: #fff;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  animation: slideInRight 0.3s ease-out;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.permissions-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #dee2e6;\n  background-color: #f8f9fa;\n}\n\n.permissions-modal-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #495057;\n  display: flex;\n  align-items: center;\n}\n\n.permissions-modal-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 4px 8px;\n  transition: color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.permissions-modal-close:hover {\n  color: #ec4899;\n}\n\n.permissions-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.permissions-policy-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.permissions-policy-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.permissions-policy-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.permissions-policy-value {\n  font-size: 14px;\n  color: #495057;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  word-break: break-all;\n  line-height: 1.5;\n}\n\n.permissions-identity-accordion-item {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #fff;\n}\n\n.permissions-identity-accordion-header {\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.permissions-identity-accordion-header:hover {\n  background-color: #e9ecef;\n}\n\n.permissions-identity-accordion-item.expanded .permissions-identity-accordion-header {\n  border-bottom: 1px solid #dee2e6;\n  background-color: #e9ecef;\n}\n\n.permissions-identity-accordion-header-content {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.permissions-identity-accordion-content {\n  padding: 12px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: slideDown 0.3s ease-out;\n}\n\n.permissions-identity-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.permissions-identity-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.permissions-policy-roles {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.permissions-roles-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.permissions-role-accordion-item {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #fff;\n}\n\n.permissions-role-accordion-header {\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.permissions-role-accordion-header:hover {\n  background-color: #e9ecef;\n}\n\n.permissions-role-accordion-item.expanded .permissions-role-accordion-header {\n  border-bottom: 1px solid #dee2e6;\n  background-color: #e9ecef;\n}\n\n.permissions-role-accordion-header-content {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.permissions-role-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.permissions-role-accordion-content {\n  padding: 8px 12px;\n  background-color: #fff;\n  animation: slideDown 0.3s ease-out;\n}\n\n.permissions-role-mrn-container {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.permissions-role-mrn-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.permissions-role-mrn-value {\n  font-size: 12px;\n  color: #6c757d;\n  font-family: monospace;\n  word-break: break-all;\n  padding: 6px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.permissions-policy-mapping {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.permissions-action-group {\n  padding: 10px 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.permissions-action-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.permissions-policies-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.permissions-policy-card {\n  padding: 8px 10px;\n  background-color: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  border-left: 3px solid #ec4899;\n}\n\n.permissions-policy-name-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.permissions-policy-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n  font-family: monospace;\n  flex: 1;\n  word-break: break-all;\n}\n\n.permissions-copy-button {\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.permissions-copy-button:hover {\n  background-color: #f8f9fa;\n  color: #ec4899;\n}\n\n.permissions-copy-button i.fa-check {\n  color: #ec4899;\n}\n\n.permissions-policy-description {\n  font-size: 12px;\n  color: #6c757d;\n  line-height: 1.5;\n}\n\n/* Features Accordion Styles */\n.features-accordion-container {\n  margin-top: 40px;\n  padding: 24px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.features-accordion-modal {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.features-accordion-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.features-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.feature-accordion-item {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #fff;\n}\n\n.feature-accordion-header {\n  padding: 10px 14px;\n  background-color: #f8f9fa;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.feature-accordion-header:hover {\n  background-color: #e9ecef;\n}\n\n.feature-accordion-item:not(:last-child) {\n  margin-bottom: 0;\n}\n\n.feature-accordion-item.expanded .feature-accordion-header {\n  border-bottom: 1px solid #dee2e6;\n  background-color: #e9ecef;\n}\n\n.feature-accordion-header-content {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.feature-accordion-feature-name {\n  flex: 1;\n  font-weight: 600;\n}\n\n.feature-accordion-route {\n  font-size: 13px;\n  color: #6c757d;\n  font-family: monospace;\n  background-color: #e9ecef;\n  padding: 4px 8px;\n  border-radius: 4px;\n  margin-left: 12px;\n}\n\n.feature-accordion-content {\n  padding: 12px 14px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 2000px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n  }\n}\n\n.feature-action-group {\n  padding: 10px 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.feature-action-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.feature-policies-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.feature-policy-item {\n  padding: 8px 10px;\n  background-color: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  border-left: 3px solid #ec4899;\n}\n\n.feature-policy-name-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.feature-policy-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n  font-family: monospace;\n  flex: 1;\n  word-break: break-all;\n}\n\n.feature-copy-button {\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.feature-copy-button:hover {\n  background-color: #f8f9fa;\n  color: #ec4899;\n}\n\n.feature-copy-button i.fa-check {\n  color: #ec4899;\n}\n\n.feature-policy-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.feature-policy-severity {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.severity-low {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.severity-medium {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.severity-high {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.feature-policy-description {\n  font-size: 12px;\n  color: #6c757d;\n  line-height: 1.5;\n}\n\n.action-button {\n  min-width: 130px;\n  padding: 12px 15px;\n  border-radius: 0;\n}\n\n.action-button-1 {\n  min-width: 120px;\n  padding: 10px 15px;\n  border-radius: 0;\n}\n\n.action-button-2 {\n  min-width: 120px;\n  padding: 6px 15px;\n  border-radius: 0;\n}\n\n.widget-outer-view-image {\n  width: 100%;\n  cursor: pointer;\n}\n\n.widget-selected-language-button {\n  width: 150px !important;\n}\n\n.widget-language-button {\n  max-width: 150px !important;\n}\n\n.widget-inner-view-image .flex-container {\n  min-height: 200px;\n}\n\n.widget-outer-view-image .flex-container {\n  text-align: center;\n  font-size: 40px;\n}\n\n.uploaded-image-cross {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.upload-image-icon {\n  position: absolute;\n  left: 35%;\n  top: 35%;\n  opacity: 0.8;\n  /* left: 0;\n  top: 0; */\n}\n\n.widget-uploaded-image {\n  width: 100%;\n}\n\n.widget-uploaded-icon {\n  width: 30%;\n}\n\n.widget-uploaded-image-full {\n  width: 100%;\n  height: 200px;\n  object-fit: contain;\n}\n\n.popup-footer {\n  margin-top: 15px;\n}\n\n.popup-footer button {\n  padding: 10px 14px;\n  margin: 10px 7px 0;\n  border-radius: 0;\n  min-width: 120px;\n}\n\n.widget-details {\n  border-top: 1px solid #c9d6de;\n  padding: 10px 10px;\n  font-size: 12px;\n}\n\n.widget-details:empty {\n  border-top: none;\n  padding: 0;\n}\n\n.one-three-widget-view,\n.single-widget-view {\n  margin: 0 -10px 25px;\n}\n\n.widget-group-view {\n  position: relative;\n  margin-bottom: 25px;\n  font-size: 14px;\n  float: none;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.widget-group-view-widgets {\n  margin-top: 15px;\n}\n\n.widget-background-yellow {\n  background-color: #ffffe0 !important;\n}\n\n.widget-group-widgets-details {\n  float: left;\n  width: calc(100% - 300px);\n  padding: 10px;\n}\n\n.banner-widget-group-view {\n  position: relative;\n  margin-bottom: 30px;\n}\n\n.banner-widget-group-view-image {\n  width: 100%;\n  height: 100px;\n  object-fit: contain;\n  background-color: #fff;\n}\n\n.action-button-full {\n  width: 100%;\n  padding: 10px 15px;\n  border-radius: 0;\n}\n\n.widget-view-container {\n  display: inline-block;\n  float: none;\n  vertical-align: top;\n}\n\n.widget-details-row {\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 5px 0 0;\n  margin: 0 5px 5px 0;\n  border-right: 1px solid #52616a;\n}\n\n.widget-details .widget-details-row:last-child {\n  border-right: none;\n}\n\n.widget-location-view {\n  font-size: 14px;\n  padding: 10px 10px 15px;\n  background-color: #ffffff;\n}\n\n.widget-location-view label,\n.widget-location-view .form-control {\n  font-size: 14px;\n}\n\n.inline-details {\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 5px 0 0;\n  margin: 0 5px 5px 0;\n  border-right: 1px solid #52616a;\n}\n\n.locations-heading {\n  padding: 10px;\n  font-weight: bold;\n  font-size: 16px;\n  background-color: #eee;\n  border: 1px solid #c9d6de;\n}\n\n.no-location-found {\n  text-align: center;\n  padding: 15px;\n  font-weight: bold;\n  font-size: 16px;\n  border: 1px solid #c9d6de;\n}\n\n.add-new-widget-group-location {\n  padding: 15px 0;\n}\n\n.add-new-widget-group-location button {\n  border-radius: 0;\n  width: 130px;\n}\n\n.taxonomy-dropdown-box label {\n  font-size: 14px;\n}\n\n.taxonomy-select-box {\n  margin: 15px 0 0;\n  padding: 0 10px;\n}\n\n.taxonomy-select-box-1 {\n  width: 15%;\n}\n\n.taxonomy-select-box-2 {\n  width: 20%;\n}\n\n.taxonomy-select-box-3 {\n  width: 30%;\n}\n\n.taxonomy-select-box-4 {\n  width: 35%;\n}\n\n.taxonomy-dropdown-box {\n  margin: 0 10px;\n}\n\n.taxonomy-select-box .Select {\n  min-width: 100%;\n}\n\n.catalog-product-table .Select {\n  margin: 0;\n}\n\n.no-data-found {\n  font-weight: bold;\n  font-size: 18px;\n  text-align: center;\n  margin-top: 15px;\n  padding: 40px 15px;\n}\n\n.single-edit-product-row tr td {\n  vertical-align: top !important;\n}\n\n.product_taxonomy_failed .product-taxonomy-details label,\n.product_upload_success .product-details .emptyPic {\n  color: #ffffff;\n}\n\n.image-error .emptyPic {\n  border-color: #a94442;\n}\n\n.landing-page-view {\n  padding: 10px;\n  margin-bottom: 30px;\n}\n\n.file-error-line {\n  margin: 0;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.variation_status_0 {\n  color: #fff !important;\n  background-color: #f0ad4e !important;\n  border-color: #eea236 !important;\n}\n\n.variation_status_1 {\n  color: #fff !important;\n  background-color: #d9534f !important;\n  border-color: #d43f3a !important;\n}\n\n.variation_status_2 {\n  color: #fff !important;\n  background-color: #5cb85c !important;\n  border-color: #4cae4c !important;\n}\n\n.nav-tabs a {\n  cursor: pointer;\n}\n\n.url-link {\n  color: #c9302c;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.bd-am-user-add .Select {\n  margin-top: 0;\n}\n\n.red-column {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n\n.green-column {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n\n.visual-search-image {\n  width: 200px;\n  position: relative;\n  margin: 10px auto;\n}\n\n.visual-search-image .product-image-2 {\n  max-height: 200px !important;\n  max-width: 200px !important;\n}\n\n.experiment-view {\n  margin-bottom: 20px;\n  display: inline-block !important;\n  float: none;\n  vertical-align: top;\n}\n\n.experiment-variants-view {\n  margin-bottom: 10px;\n}\n\n.experiment-variants-view:last-child {\n  margin-bottom: 0;\n}\n\n.experiment-variant-view {\n  margin-bottom: 15px;\n  padding: 15px;\n}\n\n.experiment-variant-remove {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.break-word {\n  word-wrap: break-word;\n}\n\n.video-rating-image {\n  max-width: 100px;\n  max-height: 200px;\n  object-fit: contain;\n}\n\n.catalog_collection_name {\n  display: inline-block;\n  padding: 0 5px;\n  border-right: 1px solid #0f213c;\n}\n\n.hidden_collection {\n  font-weight: bold;\n  background-color: #f45b69;\n  color: #ffffff;\n  padding: 2px 5px;\n}\n\n.offer-create-container {\n  width: 800px;\n  margin: auto;\n}\n\n.image-link-remove {\n  cursor: pointer;\n}\n\n.notification-detail {\n  padding: 15px 15px;\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.notification-detail-remove {\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: pointer;\n  color: #555;\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 6px 12px;\n}\n\n.padding-t-25 {\n  padding-top: 25px;\n}\n\n.upload-btn-wrapper {\n  position: relative;\n  display: block;\n  cursor: pointer;\n}\n\n.upload-btn-wrapper input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 0;\n  opacity: 0;\n  bottom: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.upload-preview {\n  color: #8e8e8e;\n  font-size: 12px;\n  padding: 5px 0;\n  display: block;\n}\n\n.upload-preview.u {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.btn-sms-portal {\n  padding: 40px;\n  background: aqua;\n  color: rgb(159, 32, 137);\n  width: 100%;\n  font-size: 18px;\n  line-height: 1.333;\n  border-radius: 0;\n  border: 1px solid rgb(159, 32, 137)54;\n}\n\n.btn-sms-primary {\n  background: aqua;\n  color: rgb(159, 32, 137);\n  width: 80%;\n  font-size: 18px;\n  line-height: 1.333;\n  border-radius: 0;\n  border: 1px solid rgb(159, 32, 137)54;\n}\n\n.sms-text-counter {\n  padding: 2px 10px;\n  background: #fafafa;\n  color: rgb(159, 32, 137);\n  border-radius: 20px;\n  border: 1px solid #ddd;\n}\n\n.sms-text-counter.danger {\n  color: rgb(192, 84, 84);\n}\n\n.sms-message-display {\n  min-height: 100px;\n  display: block;\n  display: block;\n  padding: 10px;\n  font-size: 16px;\n  line-height: 1.42857143;\n  color: #333333;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  font-family: monospace;\n  overflow: auto;\n  text-overflow: ellipsis;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  /* -webkit-appearance: none;  */\n  margin: 0;\n}\n\n.reduce-margin-15 {\n  margin-left: -15px;\n}\n\n.margin-left-15 {\n  margin-left: 15px;\n}\n\n.margin-left-10 {\n  margin-left: 10px;\n}\n\n.margin-left-5 {\n  margin-left: 5px;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.justify-content-center {\n  justify-content: center;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  opacity: 1;\n}\n\n/*.nav > li > a:hover, .nav > li > a:focus {\n    text-decoration: none;\n    background-color: rgb(159, 32, 137) !important;\n}*/\n\n.user-profile-view input {\n  width: 100%;\n  padding: 5px 10px;\n}\n\n.user-profile-view label {\n  padding: 5px 10px;\n  margin-bottom: 0;\n}\n\n.react-datepicker-popper {\n  z-index: 10;\n}\n\n.simple-table th,\ntd {\n  padding: 5px !important;\n}\n\n.staticEditorWorkBox {\n  height: 400px !important;\n  border: 1px solid #f1f1f1;\n}\n\n.row-flex {\n  display: flex;\n  flex-direction: row;\n}\n\n.col-flex {\n  display: flex;\n  flex-direction: column;\n}\n\n.space-even-flexBox {\n  justify-content: center;\n  align-items: center;\n}\n\n.sectionBox {\n  border: 1px solid silver;\n  padding: 10px 0;\n  margin: 10px 0;\n}\n\n.pageItem {\n  padding: 10px;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.editorContainer {\n  display: flex;\n  align-self: center;\n}\n\n.tox-notifications-container {\n  display: none;\n}\n\n.leaderboard-btn {\n  min-width: 120px;\n  padding: 8px 10px;\n  border-radius: 0;\n  font-weight: bold;\n}\n\n.leaderboard-head-btn {\n  margin: 25px 40px;\n}\n\n.form__imageab {\n  position: relative;\n  padding-top: 15px;\n}\n\n.form__imageab-label {\n  display: inline-block;\n  position: absolute;\n  color: #c7c7c7;\n  font-weight: 400;\n  background: white;\n  margin: 0;\n  font-size: 12px;\n  top: 8px;\n  left: 20px;\n  padding: 0 5px;\n}\n\n.form__imageab-input {\n  display: block;\n  padding: 10px 10px;\n  border: 1px solid #c7c7c7;\n}\n\n.img_ab-wrapper {\n  border: 1px solid #ddd;\n  display: table-cell;\n  vertical-align: middle;\n  align-items: center;\n  margin-bottom: 10px;\n  background-color: #dddddd94;\n  height: 150px;\n  max-width: 200px;\n}\n\n.img_ab-wrapper img {\n  max-height: 100%;\n  margin: 0 auto;\n}\n\n.img_ab-err {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.rule-engine-create-table {\n  width: 60%;\n}\n\n.rule-engine-test-table {\n  width: 35%;\n  margin-left: 3%;\n}\n\n.rule-engine-heading {\n  background: rgb(159, 32, 137);\n  color: #fff;\n}\n\n.rule-engine-create-table tr {\n  width: 100%;\n}\n\n.rule-engine-create-table tr th {\n  padding: 5px !important;\n}\n\n.rule-engine-create-table tr th:nth-child(1) {\n  width: 20%;\n}\n\n.rule-engine-create-table tr th:nth-child(2) {\n  width: 80%;\n}\n\n.rule-engine-create-table tr th:nth-child(2) textarea {\n  width: 100%;\n  min-height: 100px;\n  padding: 10px;\n}\n\n.test-row-height {\n  height: 500px;\n}\n\n.deactivated-button {\n  opacity: 0.5;\n}\n\n.test-validation-input-box {\n  width: 100%;\n  min-height: 200px;\n  padding: 10px;\n}\n\n.supplier-address .Select {\n  min-width: 150px;\n}\n\n.clp-search-box {\n  font-size: 20px;\n  padding: 2px;\n  margin: 10px;\n}\n\n.card-catalog {\n  position: relative;\n  cursor: pointer;\n  min-height: 190px;\n  height: auto;\n  margin-top: 20px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 2px;\n  max-width: 270px;\n}\n\n.card-na {\n}\n\n.card-catalog .card-badge {\n  position: absolute;\n  border-radius: 50%;\n  background: white;\n  padding: 5px;\n  text-align: center;\n  top: -17px;\n  width: 34px;\n  left: -17px;\n  border: 1px solid #bebbbb;\n}\n\n.modal-product-card {\n  border: 1px solid #ddd;\n  margin: 15px 0;\n  padding: 0 15px;\n  cursor: pointer;\n}\n\n.horizontall-scroller {\n  margin: 15px 0;\n  padding: 0;\n  white-space: nowrap;\n  max-width: 100%;\n  overflow-x: auto;\n  border: 1px solid #f8f8f8;\n}\n\n.scroller-element {\n  display: inline;\n  border: 1px solid #ddd;\n  margin: 0 10px;\n}\n\n.error-modal-body {\n  padding: 0px 15px 15px;\n  max-height: calc(100vh - 210px);\n  overflow-y: auto;\n}\n\n.error-message {\n  color: red;\n  text-align: center;\n}\n\n.btn-light {\n  color: red;\n  margin-top: 5px;\n}\n\n.cat-nav {\n  display: flex;\n  margin-top: 30px;\n  padding: 10px;\n}\n\n.cat-title {\n  margin-left: 10px;\n  padding: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.dotted-box {\n  width: 120px;\n  height: 120px;\n  border-radius: 4px;\n  border: solid 1px #eb4f85;\n  background-color: #fff;\n}\n\n.intent-rule-table {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #c9d6de;\n}\n\n.intent-rule-td {\n  display: flex;\n  flex-direction: column;\n}\n\n.intent-add-search {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.search-field-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.search-field {\n  display: flex;\n  align-items: center;\n}\n\n.search-input {\n  padding: 10px;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.search-icon {\n  margin-right: 8px;\n}\n\n.add-condition-btn {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n\n.add-condition-btn-text {\n  padding-right: 5px;\n  color: #52616a;\n  font-size: 18px;\n  margin-left: 8px;\n  font-weight: inherit;\n}\n\n.intent-error-msg {\n  background-color: #ffd4d4;\n  text-align: center;\n  padding: 5px;\n  margin-bottom: 50px;\n}\n\n.intent-error-text {\n  color: #fc3a3a;\n  font-size: 25px;\n  text-align: center;\n}\n\n.intent-add-edit-btn {\n  margin-top: 50px;\n  margin-left: 20px;\n}\n\n.rule-condition {\n  padding: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.rule-condition-wrapper {\n  display: flex;\n  margin-right: 10px;\n  align-items: center;\n  border: 1px solid #ebecf0;\n  background-color: #fafbfc;\n}\n\n.fa-trash {\n  color: red;\n  font-size: 25px;\n}\n\n.rule-action {\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n\n.rule-action-container {\n  margin-top: 10px;\n  margin-bottom: 5px;\n  padding: 5px;\n  border: 1px solid #ebecf0;\n  border-radius: 5px;\n  background-color: #fafbfc;\n}\n\n.rule-action-name {\n  display: flex;\n  margin: 5px;\n  padding: 3px;\n  align-items: center;\n}\n\n.fa-plus-circle {\n  padding-right: 5px;\n  margin-left: 20px;\n  color: #52616a;\n  font-size: 18px;\n}\n\n.fa-close {\n  font-size: 25px;\n  color: #f54814;\n}\n\n.action-cat-container {\n  display: flex;\n  margin-left: 15px;\n  flex-direction: column;\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n\n.action-sub-container {\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.arrow-pointer {\n  color: #52616a;\n  margin-right: 5px;\n}\n\n.action-option-container {\n  display: flex;\n  flex-direction: column;\n  margin-left: 20px;\n}\n\n.action-option-list {\n  margin-left: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.opt-del {\n  margin-left: 15px;\n}\n\n.border-gray {\n  border: 1px solid #c9d6de;\n}\n\n.uat-images {\n  width: 160px;\n  height: 160px;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.uat-content-left {\n  width: 530px;\n  max-height: calc(100vh - 170px);\n  overflow: scroll;\n}\n\n.uat-content-right {\n  width: calc(100% - 530px);\n  max-height: calc(100vh - 170px);\n  overflow: scroll;\n}\n\n.uat-content-right .radio-inline:first-child {\n  margin-left: 5px;\n}\n\n.color-black {\n  color: black;\n}\n\n.color-007 {\n  color: #007eff\n}\n\n.border-radius-5 {\n  border-radius: 5px;\n}\n\n.notice-input-card {\n  margin: 10px;\n  margin-bottom: 30px;\n  box-shadow: 0 0 5px #5a5a5a3f;\n  padding: 20px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.notice-input-card-input {\n  width: 100%;\n  height: 35px;\n  padding: 5px;\n  border-radius: 2px;\n  border: 1px solid rgb(177, 177, 177);\n}\n\n.notice-input-card-input:focus {\n  outline: none;\n  border: 1.5px solid rgb(0, 0, 0);\n  box-shadow: 0 0 10px #5a5a5a3f;\n}\n\n.card-input-container {\n  margin-top: 30px;\n}\n\n.card-input-container label {\n  font-weight: 400;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.card-input-container textarea {\n  width: 100%;\n  min-height: 200px;\n  border: 1px solid rgb(177, 177, 177);\n  border-radius: 3px;\n  padding: 5px;\n}\n\n.card-input-container span {\n  font-size: 13px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-left: 10px;\n}\n\n.card-notice-button-container {\n  margin-top: 25px;\n  margin-bottom: 10px;\n}\n\n.card-notice-button-container button {\n  height: 40px;\n  width: 250px;\n  border-radius: 5px;\n  font-size: 14px;\n  letter-spacing: 0.05em;\n}\n\n.card-notice-clear-button {\n  background: transparent;\n  border: 0px;\n}\n\n.card-notice-clear-button:hover {\n  box-shadow: 0 0 5px #5a5a5a36;\n}\n\n.card-notice-submit-button {\n  border: 0px;\n  background-color: #eb4e85;\n  color: #fff;\n}\n\n.single-notice-card {\n  box-shadow: 0 0 10px #5a5a5a18;\n  padding: 20px;\n  border-radius: 10px;\n  border: 1px solid rgba(155, 155, 155, 0.527);\n  margin: 3px 10px 40px 10px;\n  overflow: hidden;\n}\n\n.notice-container {\n  margin-left: 50px;\n  max-width: 665px;\n}\n\n.horizontal-center {\n  /* left: 50%;\n  position: absolute;\n  transform: translate(-50%, 0px);\n  width: 50%; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.single-notice-card-heading {\n  margin: -20px;\n  padding: 20px;\n  background-color: #d3d3d394;\n\n  font-weight: 400;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-size: 12px;\n\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n\n.single-notice-card-title {\n  font-size: 20px;\n  text-transform: capitalize;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n}\n\n.single-notice-edit-button {\n  width: 100%;\n  height: 40px;\n  border-radius: 5px;\n  border: 0px;\n  background-color: #eb4e85;\n  color: #fff;\n}\n\n.notice-card-edit-block {\n  text-align: center;\n  background: #ff00002e;\n  margin: -20px;\n  margin-top: 30px;\n  color: red;\n  letter-spacing: 0.05em;\n  padding: 10px;\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.button-loading {\n  opacity: 50%;\n}\n\n.spinner-center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.row-margin-container {\n  display: flex;\n  margin: 10px 0px 20px 0px;\n}\n\n.form-group-display-flex {\n  display: flex;\n  justify-content: space-between;\n}\n\n.form-group-display-flex .reseller-name {\n  margin-right: 20px;\n}\n\n.form-group-display-flex .reseller-user-id {\n  margin-right: 20%;\n}\n\n.overflow-wrap {\n  overflow-wrap: anywhere;\n}\n\n.width-100pc {\n  width: 100% !important;\n}\n\n.sidebar > .sidebar-nav > .nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n\n.sidebar > .nav > li {\n  width: 100%;\n}\n\n.bulk-widget-upload {\n  /* height: 60px; */\n  padding: 10px;\n  margin-bottom: 30px;\n}\n\n.bulk-upload {\n  margin: 10px;\n  padding: 10px;\n  text-align: center;\n  border: 1px solid #ededed;\n  border-bottom-width: 3px;\n  border-left-width: 2px;\n  cursor: pointer;\n  opacity: 0.9;\n  overflow: hidden;\n}\n\n.bulk-upload-diable {\n  background-color: #eee;\n  opacity: 0.8;\n}\n\n.bulk-upload-icon {\n  display: block;\n  width: 95%;\n  height: 40%;\n  position: absolute;\n  left: 20px;\n  bottom: 20px;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.d-flex {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.m-b-10 {\n  margin-bottom: 10px;\n}\n\n.m-b-20 {\n  margin-bottom: 20px;\n}\n\n.w-30 {\n  width: 30%;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n\n/**************\n  css to overwrite bootstrap 5 css to look like old adminpanel starts here\n***************/\na {\n  text-decoration: none !important;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.navbar-right > div > a {\n  color: #fff;\n}\n\n.btn {\n  font-size: 14px;\n}\n\n.btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n\n.btn-group-justified > .btn-group {\n  display: table-cell;\n  float: none;\n  width: 1%;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px;\n}\n\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n\n#catalog-info-edit input[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  margin-bottom: 0;\n  margin-top: 2px;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\n\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373;\n}\n\n.has-error .help-block, .has-error .control-label,\n.has-error .radio, .has-error .checkbox,\n.has-error .radio-inline, .has-error .checkbox-inline,\n.has-error.radio label, .has-error.checkbox label,\n.has-error.radio-inline label, .has-error.checkbox-inline label {\n  color: #a94442;\n}\n\n.form-control:read-only {\n  background-color: #fff;\n}\n\n.panel {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);\n  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);\n}\n\n.panel-default {\n  border-color: #ddd;\n}\n\n.panel-body {\n  padding: 15px;\n}\n\n.col-md-offset-3 {\n  margin-left: 25%;\n}\n\n.page-header {\n  padding-bottom: 9px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.nav-tabs.nav-justified {\n  width: 100%;\n  border-bottom: 0;\n}\n\n.nav.nav-tabs.nav-justified > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n\n.nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n\n.nav-tabs.nav-justified > li > a {\n  margin-bottom: 5px;\n  text-align: center;\n}\n\nh4, .h4 {\n  font-size: 18px;\n}\n\nh5, .h5 {\n  font-size: 14px;\n}\n\nh4, .h4, h5, .h5, h6, .h6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  word-break: break-word;\n}\n\n.img-responsive, .thumbnail > img, .thumbnail a > img, .carousel-inner > .item > img, .carousel-inner > .item > a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\nh3, .h3 {\n  word-break: break-word;\n}\n\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1,\n.col-xs-2, .col-sm-2, .col-md-2, .col-lg-2,\n.col-xs-3, .col-sm-3, .col-md-3, .col-lg-3,\n.col-xs-4, .col-sm-4, .col-md-4, .col-lg-4,\n.col-xs-5, .col-sm-5, .col-md-5, .col-lg-5,\n.col-xs-6, .col-sm-6, .col-md-6, .col-lg-6,\n.col-xs-7, .col-sm-7, .col-md-7, .col-lg-7,\n.col-xs-8, .col-sm-8, .col-md-8, .col-lg-8,\n.col-xs-9, .col-sm-9, .col-md-9, .col-lg-9,\n.col-xs-10, .col-sm-10, .col-md-10, .col-lg-10,\n.col-xs-11, .col-sm-11, .col-md-11, .col-lg-11,\n.col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 1px;\n}\n\n.list-group-flush > .list-group-item {\n  border-width: 1px;\n}\n\n.flex {\n  display: flex;\n}\n\n.modal-dialog {\n  pointer-events: inherit !important;\n}\n\n@media only screen and (min-width: 768px) {\n  .nav-tabs.nav-justified > li {\n    display: table-cell;\n    width: 25%;\n  }\n\n  .nav-tabs.nav-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n    width: 100%;\n  }\n\n  .nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:hover, .nav-tabs.nav-justified > .active > a:focus {\n    border-bottom-color: #fff;\n  }\n}\n\n/**************\n  css to overwrite bootstrap 5 css to look like old adminpanel ends here\n***************/\n\n.custom-date-picker .react-datepicker__input-container input {\n  width: 100%;\n}\n\n\n.loader-center-align {\n  position: fixed;\n  left: 0px;\n  top: 50%;\n  width: 100%;\n}\n\n.toggle-div {\n  width: 50px;\n  height: 26px;\n  border: 2px solid rgb(5, 70, 5);\n  border-radius: 15px;\n  display: flex;\n  cursor: pointer;\n}\n\n.toggle-checked {\n  justify-content: flex-end;\n}\n\n.toggle-btn {\n  width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  background-color: rgb(5, 70, 5);\n}\n\n.main-wrapper-watchers {\n  border: 1px solid #c9d6de;\n  padding: 5px;\n  min-height: 34px;\n  max-height: 150px;\n  overflow-y: scroll;\n  position: relative;\n}\n\n.input-watchers {\n  border: none;\n  position: absolute;\n  width: -webkit-fill-available;\n  color: black;\n}\n\n.wachers-error {\n  margin: 0;\n  font-size: 90%;\n  color: red;\n}\n\n.tag-item-watchers {\n  background-color: #d4d5d6;\n  display: inline-block;\n  font-size: 14px;\n  border-radius: 30px;\n  padding: 0 4px 0 6px;\n  display: inline-flex;\n  align-items: center;\n  margin: 0 0.3rem 0.3rem 0;\n}\n\n.tag-item-watchers > .button-watchers {\n  background-color: white;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  margin-left: 10px;\n  padding: 0;\n  line-height: 1;\n  display: flex;\n  justify-content: center;\n}\n\n/* Audience Status Styles */\n\n.audience-status-wrapper {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #C9D6DE;\n  padding: 16px;\n  gap: 12px;\n}\n\n.audience-status-common {\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.audience-status-date {\n  display: flex;\n  gap: 12px;\n  width: max-content;\n  background-color: #F0F0F0;\n  padding: 4px 8px;\n  border-radius: 5px;\n}\n\n.audience-status-state .audience-status-refreshed {\n  color: #038D63;\n  background-color: #D3F4EA;\n  padding: 4px 8px;\n  border-radius: 5px;\n}\n\n.audience-status-msg {\n  display: flex;\n  margin-top: 12px;\n  gap: 6px;\n}\n\n.audience-status-queue-wrapper {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.audience-status-state .audience-status-queue {\n  color: #F4B619;\n  background-color: #FFF4D7;\n  padding: 4px 8px;\n  border-radius: 5px;\n}\n\n.audience-status-queue-content {\n  padding: 4px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.audience-status-steps {\n  display: flex;\n  flex-direction: column;\n}\n\n.circle-background,\n.circle-progress {\n  fill: none;\n}\n\n.circle-background {\n  stroke: #D8E3FD;\n}\n\n.circle-progress {\n  stroke: #306CF5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.modal-btn-common {\n  color: #306CF5;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.action-button-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.display-flex-justify-space-between-align-center {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.display-flex-direction-column-align-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.react-diff-view-wrapper {\n  margin-top: 1rem;\n  margin-bottom: 3rem;\n  width: 70rem;\n  max-height: 40rem;\n  overflow-y: scroll;\n  border: .2px solid lightgray;\n}\n\n.search-widget-group-id-wrapper {\n  display: flex;\n  align-items: center;\n  margin-left: 7rem;\n}\n\n.search-text-area {\n  width: 230px;\n}\n\n.search-btn {\n  margin-top: 15px;\n  background-color: #0d6efd;\n  color: white;\n}\n\n.btn-primary {\n  background-color: #9F2089;\n  border: none;\n}\n\n.btn-info {\n  background-color: #9F2089;\n  border: none;\n  color: white;\n\n}\n\n.btn-primary:hover {\n  background-color: #9F2089;\n}\n\n.margin-left-minus-10-rem {\n  margin-left: -10rem;\n}\n\n.default-button {\n  border: none;\n  background: none;\n  padding: 10px 15px;\n  display: inline-block;\n}\n\n.default-button.active {\n  color: #dc3545 !important;\n}\n\n.card-title {\n  margin-bottom: 0;\n}\n\n.card {\n  box-shadow: none;\n  margin-bottom: 15px;\n  overflow: unset;\n}\n\n.card:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
